// @ts-nocheck
import React, { ChangeEvent, useState, useEffect } from 'react'
import styles from './Results.module.css'
import { Divider, Modal, Grid, Typography } from '@mui/material'
import { COLOR_PRIMARY } from 'routes/color-constants'
import { useStyles } from 'features/matchings/Matching.styles'
import { useTranslation } from 'react-i18next'
import { firstValueFrom } from 'rxjs';
import {
  Button,
  Checkbox,
  createStyles,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Theme,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
} from '@material-ui/core'
import { Head } from 'components/table/Head'
import { Body } from 'components/table/Body'
import CloseIcon from '@material-ui/icons/Close'
import { Legend } from 'components/legend/Legend'
import { customOrder, RolePGDTest, rolePgdTest } from 'modules/users/enums/RoleType'
import { validColors, RECOMBINATION_FLANK, MIN_BLOCK_MARKERS } from 'modules/analysis/enum/ColorEnum'
import { getProjectContainer } from '../../container/project-module'
import { ProjectService } from '../../modules/projects/services/ProjectService'
import { PROJECT_SERVICE_KEY } from '../../modules/projects'
import { Project, ProjectAnalysis } from '../../modules/projects/models/Project'
import { getAuthContainer } from '../../container/auth-modules'
import { AUTH_SERVICE_KEY } from '../../modules/auth'
import { AuthService } from '../../modules/auth/services/AuthService'
import { MutationsPositionService } from '../../modules/mutationsPosition/services/MutationsPositionService'
import { MUTATIONS_POSITION_SERVICE_KEY } from '../../modules/mutationsPosition'
import { getMutationsPositionContainer } from '../../container/mutationsPositions-module'
import { getWordContainer } from '../../container/word-module'
import { WordService } from '../../modules/word/services/WordService'
import { WORD_SERVICE_KEY } from '../../modules/word'
import { WordDTO } from '../../modules/word/models/Word'
import { makeStyles } from '@material-ui/core/styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import InfoOutlined from '@material-ui/icons/InfoOutlined'
import { DirectTestingStatus, FinalStatus, Status } from 'modules/individuals/enums/Status'
import CircularProgress from '@mui/material/CircularProgress'
import { Individual } from 'modules/individuals/models/Individual'
import { Embryo } from 'modules/embryos/models/Embryo'
import { commonStyles } from 'common/styles/Styles'
import { statusTitle, finalStatusTitle } from '../../modules/individuals/enums/Status'
import { Field } from 'components/table'
import { getTestContainer } from 'container/test-module'
import { MutationsPosition } from 'modules/mutationsPosition/models/MutationsPosition'
import { TEST_SERVICE_KEY } from 'modules/tests'
import { TestService } from 'modules/tests/services/TestService'
import {
  confidenceLevel,
  confidenceLevelEmbryo as confidenceLevelEmbryoInfo,
} from '../../common/utils/confidenceLevel'
import { getIndividualContainer } from 'container/individual-module'
import { IndividualService } from 'modules/individuals/services/IndividualService'
import { INDIVIDUAL_SERVICE_KEY } from 'modules/individuals'
import { EmbryoService } from 'modules/embryos/services/EmbryoService'
import { getEmbryoContainer } from 'container/embryo-module'
import { EMBRYO_SERVICE_KEY } from 'modules/embryos'
import { getDirectTestingContainer } from 'container/directTesting-module'
import { DIRECT_TESTING_SERVICE_KEY } from 'modules/directTesting'
import { DirectTestingService } from 'modules/directTesting/services/DirectTestingService'
import { DirectTesting } from 'modules/directTesting/models/DirectTesting'
import { Individuals } from 'modules/individuals/enums/Individuals'
import { styled } from '@mui/material/styles'
import { IGV } from './IGV'
import { Query, QueryParam } from 'common/api/Query'
import { exportResultsToExcel } from './exportResultsToExcel'

const projectService = getProjectContainer().get<ProjectService>(PROJECT_SERVICE_KEY)
const authService = getAuthContainer().get<AuthService>(AUTH_SERVICE_KEY)
const mutationService = getMutationsPositionContainer().get<MutationsPositionService>(
  MUTATIONS_POSITION_SERVICE_KEY
)
const wordService = getWordContainer().get<WordService>(WORD_SERVICE_KEY)
const testService = getTestContainer().get<TestService>(TEST_SERVICE_KEY)
const individualService = getIndividualContainer().get<IndividualService>(INDIVIDUAL_SERVICE_KEY)
const embryoService = getEmbryoContainer().get<EmbryoService>(EMBRYO_SERVICE_KEY)
const directDetectionService = getDirectTestingContainer().get<DirectTestingService>(
  DIRECT_TESTING_SERVICE_KEY
)

export type ResultsProps = {
  project?: ProjectAnalysis
  setProject: (s: ProjectAnalysis) => void
  data: any
  return?: (b: boolean) => void
  currentStep?: number
  individuals: Individual[]
  seeSex: boolean
  embryos?: Embryo[]
  setCurrentStep: (n: number) => void
  setIndividuals: (i: Individual[]) => void
  setViewResult: (v: boolean) => void
  setEmbryos: (e: Embryo[]) => void
  setFromIndi: (b: boolean) => void
  setFromEmb: (b: boolean) => void
}

type ConfidenceData = {
  level: number
  Information: string
  color: string
}

type EmbryoConfidence = {
  upInfo: number
  inInfo: number
  downInfo: number
  levelConfidence: ConfidenceData
  validated: boolean
  kpForBoth: boolean
  inconclusive: boolean
}

const usaStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerAllele: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      width: '35%',
      height: 'auto',
      padding: '30px',
      minWidth: '400px',
      borderRadius: '8px',
      paddingTop: '21px',
      justifyContent: 'center',
      display: 'flex',
      alignContent: 'center',
      flexDirection: 'column',
    },
    alleleTitle: {
      fontWeight: 'bold',
      fontSize: '15px',
      marginTop: '1.5%',
      alignSelf: 'center',
    },
    alleleDivs: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
      alignSelf: 'center',
      marginTop: '5.5%',
    },
    alleleCloseIcon: {
      position: 'absolute',
      top: '6px',
      right: '9px',
      cursor: 'pointer',
    },
    formControl: {
      minWidth: 120,
    },
    toggle: {
      width: 68,
      height: 47,
      pading: 0,
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 30,
        height: 30,
      },
      '& .MuiSwitch-track': {
        borderRadius: 47 / 2,
      },
    },
  })
)

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .MuiTooltip-tooltip {
    font-size: 15px;
    background-color: rgb(125, 191, 220);
  }
`
export function Results(props: ResultsProps): JSX.Element {
  const stylesComon = commonStyles()
  const classes = useStyles({ color: COLOR_PRIMARY })
  const { t } = useTranslation()
  const [motherInfo, setMotherInfo] = useState<boolean>(true)
  const [fatherInfo, setFatherInfo] = useState<boolean>(true)
  const [noInfo, setNoInfo] = useState<boolean>(false)
  const [semiInfo, setSemiInfo] = useState<boolean>(false)
  const [lowPositions, setLowPositions] = useState<boolean>(false)
  const [afOn, setAfOn] = useState<boolean>(false)
  const [qualityCoverage, setQualityCoverage] = useState<boolean>(false)
  const [alleleModal, setAlleleModal] = useState<boolean>(false)
  const [currentPosition, setCurrentPosition] = useState<number>()
  const [currentAIndex, setCurrentAIndex] = useState<number>()
  const [data2, setData2] = useState<any>(props.data)
  const [project, setProject] = useState<Project>()
  const [selectedOption, setSelectedOption] = useState('')
  const [mutationChanges, setMutationChanges] = useState<boolean>(false)
  const [saveMutationModal, setSaveMutationModal] = useState<boolean>(false)
  const [changes, setChanges] = useState<boolean>(false)
  const [changesModal, setChangesModal] = useState<boolean>(false)
  const [currentIndividual, setCurrentIndividual] = useState<any>({})
  const [wordsChanges, setWordsChanges] = useState<WordDTO[]>([])
  const [dataLoading, setDataLoading] = useState<Boolean>(false)
  const [individuals, setIndividuals] = useState<Individual[]>(props.individuals)
  const [embryos, setEmbryos] = useState<Embryo[]>(props?.embryos)
  const [maternalVar, setMaternalVar] = useState<MutationsPosition[]>([])
  const [paternalVar, setPaternalVar] = useState<MutationsPosition[]>([])
  const [isDisable, setIsDisable] = useState<boolean>(false)
  const [testData, setTestData] = useState<Report>()
  const [upVari, setUpVari] = useState<number>(0)
  const [inVari, setInVari] = useState<number>(0)
  const [downVari, setDownVari] = useState<number>(0)
  const [upVari2, setUpVari2] = useState<number>(0)
  const [inVari2, setInVari2] = useState<number>(0)
  const [downVari2, setDownVari2] = useState<number>(0)
  const [upVariFather, setUpVariFather] = useState<number>(0)
  const [inVariFather, setInVariFather] = useState<number>(0)
  const [downVariFather, setDownVariFather] = useState<number>(0)
  const [upVari2Father, setUpVari2Father] = useState<number>(0)
  const [inVari2Father, setInVari2Father] = useState<number>(0)
  const [downVari2Father, setDownVari2Father] = useState<number>(0)
  const [confidenceMotherRange, setConfidenceMotherRange] = useState<ConfidenceData>()
  const [confidenceFatherRange, setConfidenceFatherRange] = useState<ConfidenceData>()
  const [motherValidated, setMotherValidated] = useState<boolean>()
  const [fatherValidated, setFatherValidated] = useState<boolean>()
  const [maternalDirect, setMaternalDirect] = useState<DirectTesting>([])
  const [paternalDirect, setPaternalDirect] = useState<DirectTesting>([])
  const [embryosConfMoth, setEmbryosConfMoth] = useState<EmbryoConfidence[]>([])
  const [embryosConfFath, setEmbryosConfFath] = useState<EmbryoConfidence[]>([])
  const [embryoDT, setEmbryoDT] = useState<DirectTesting[]>([])
  const [igvEnabled, setIgvEnabled] = useState<boolean>(false)
  const [selectedLocus, setSelectedLocus] = useState<string>('')
  const [hasIgvTracks, setHasIgvTracks] = useState<boolean>(false)
  const [alleleModes, setAlleleModes] = useState<Record<string, 'OFF' | 'HET' | 'HOM'>>({})

  const options = [
    { value: '#e8d863', label: t('yellowM') },
    { value: '#09d6e8', label: t('blueM') },
    { value: '#ed6afa', label: t('pinkM') },
    { value: '#03de6c', label: t('greenM') },
    { value: '#ff7b54', label: t('orangeM') },
    { value: '#ddeafb', label: t('whiteM') },
    { value: '#e4a397', label: t('incongruityM') },
    { value: 'rgb(153, 153, 153)', label: t('lowqualitycoverageM') },
  ]

  const fields: Field<any>[] = [
    {
      sortable: false,
      searchable: false,
      label: '',
      name: 'view',
    },
    {
      sortable: false,
      searchable: false,
      label: t('individual'),
      name: 'individual',
    },
    {
      sortable: false,
      searchable: false,
      label: t('fileName'),
      name: 'fileName',
    },
    {
      sortable: false,
      searchable: false,
      label: t('status'),
      name: 'status',
    },
    {
      sortable: false,
      searchable: false,
      label: t('mutation'),
      name: 'mutation',
    },
    {
      sortable: false,
      searchable: false,
      label: 'NOCALL %',
      name: 'NOCALL %',
    },
  ]

  const fields2: Field<any>[] = [
    {
      sortable: false,
      searchable: false,
      label: '',
      name: 'view',
    },
    {
      sortable: false,
      searchable: false,
      label: t('sampleName'),
      name: 'name',
    },
    {
      sortable: false,
      searchable: false,
      label: t('fileName'),
      name: 'fileName',
    },
    {
      sortable: false,
      searchable: false,
      label: t('status'),
      name: 'status',
    },
    ...(props.seeSex
      ? [
          {
            sortable: false,
            searchable: false,
            label: t('sex'),
            name: 'sex',
          },
        ]
      : []),
    {
      sortable: false,
      searchable: false,
      label: 'NOCALL %',
      name: 'NOCALL %',
    },
  ]

const filterResult = (embryoResult) => {
  return embryoResult?.filter((element: any) => {
    const isInformative = ['mother_info', 'father_info', 'both_info'].includes(element.individualType);
    
    const hasProblematicEmbryo = element.individual?.some((ind: any) => 
      ind.role !== RolePGDTest.Embryo && (
        (typeof ind?.quality === 'number' && ind.quality <= 20) ||
        (typeof ind?.coverage === 'number' && ind.coverage <= 10) ||
        ind?.a1?.word === '-' || 
        ind?.a2?.word === '-'
      )
    );

    return isInformative && !hasProblematicEmbryo;
  }) || [];
}


  const getColor = async () => {
      const promises = embryos.map(e =>
        embryoService.getByID(e.id).toPromise() // o firstValueFrom(...)
      );

      const results = await Promise.all(promises);
      return results.filter((r): r is Embryos => !!r);
  }


  useEffect(() => {
    if (props.project) {
      projectService.getByID(props.project?.id || '').subscribe((res) => {
        res != undefined && setProject(res)
      })
      testService.report(props.project?.id || '').subscribe((res) => {
        setTestData(res)
      })
    }
  }, [props.project])

// hasConsecutiveColor comprueba si, a partir de fromIdx y avanzando en la
// dirección `step`, hay al menos `count` marcadores consecutivos del
// embrión con el color indicado. Un marcador aislado (sin este soporte) no
// basta para declarar un cruce (crossover); debe coincidir con
// MIN_BLOCK_MARKERS en el backend (embryo.go).
const hasConsecutiveColor = (
  embr: any[],
  fromIdx: number,
  step: 1 | -1,
  allele: 'a1' | 'a2',
  color: string,
  embryoName: string,
  count: number
): boolean => {
  let matched = 0
  for (let idx = fromIdx; idx >= 0 && idx < embr.length && matched < count; idx += step) {
    const result = embr[idx]?.individual?.find((r: any) => r.name === embryoName)
    if (result?.[allele]?.color !== color) break
    matched++
  }
  return matched >= count
}

const getRecomPosition = (
  embr: any[],          // array de filas informativas
  a1Colors: string[],
  a2Colors: string[],
  embryo: any,           // embrión actual (con sampleName)
  winStartA1: number,
  winEndA1: number,
  winStartA2: number,
  winEndA2: number
): [number, number] => {
  let recom1 = 0;
  let recom2 = 0;

  embr?.forEach((row, idx) => {
    const embryoResult = row?.individual?.find(
      (r: any) => r.name === embryo?.name
    );

    if (!embryoResult) return;

    // ---- A1: recom1 ----
    // Solo tiene sentido buscar el punto de cruce si el backend ya
    // determino que hay mas de un bloque haplotipico (a1Colors.length > 1),
    // y solo dentro de la ventana diagnostica alrededor de la variante.
    if (
      recom1 === 0 &&
      a1Colors.length > 1 &&
      validColors.includes(embryoResult?.a1?.color) &&
      row.position >= winStartA1 &&
      row.position <= winEndA1
    ) {
      const base2 = a1Colors[a1Colors.length - 1];
      const isRecom =
        embryoResult?.a1?.color === base2 &&
        (hasConsecutiveColor(embr, idx, 1, 'a1', base2, embryo?.name, MIN_BLOCK_MARKERS) ||
          hasConsecutiveColor(embr, idx, -1, 'a1', base2, embryo?.name, MIN_BLOCK_MARKERS));

      if (isRecom) {
        recom1 = row.position;
      }
    }

    // ---- A2: recom2 ----
    if (
      recom2 === 0 &&
      a2Colors.length > 1 &&
      validColors.includes(embryoResult?.a2?.color) &&
      row.position >= winStartA2 &&
      row.position <= winEndA2
    ) {
      const base2 = a2Colors[a2Colors.length - 1];
      const isRecom =
        embryoResult?.a2?.color === base2 &&
        (hasConsecutiveColor(embr, idx, 1, 'a2', base2, embryo?.name, MIN_BLOCK_MARKERS) ||
          hasConsecutiveColor(embr, idx, -1, 'a2', base2, embryo?.name, MIN_BLOCK_MARKERS));

      if (isRecom) {
        recom2 = row.position;
      }
    }
  });

  return [recom1, recom2];
};


  const handleEmbryoIndo = async () => {
    setEmbryosConfMoth([])
    setEmbryosConfFath([])
    const auxMother: EmbryoConfidence[] = []
    const auxFather: EmbryoConfidence[] = []

    let min: number
    let min2: number
    let max: number
    let max2: number
    let upMother: number
    let inMother: number
    let downMother: number
    let upFather: number
    let inFather: number
    let downFather: number
    let upInfoAmpFather: number
    let downInfoAmpFather: number
    let upInfoAmpMother: number
    let downInfoAmpMother: number
    let inconclusiveKeyMother: number
    let inconclusiveKeyFather: number
    let directDetection: boolean
    let directDetectionFather: boolean
    let a1Colors: string[]
    let a2Colors: string[]
    let auxEmbrios:Embryos[]
    let upMotherC2: number
    let downMotherC2: number
    let upFatherC2: number
    let downFatherC2: number

    auxEmbrios = await getColor()

    
    
    
    for (const embryoaux of embryos) {
      
    min = 0
    min2 = 0
    max = 0
    max2 = 0
    upMother = 0    
    upMotherC2 = 0

    inMother = 0
    downMother = 0    
    downMotherC2 = 0

    upFather = 0
    upFatherC2 = 0

    inFather = 0
    downFather = 0
    downFatherC2 = 0

    upInfoAmpFather = 0
    downInfoAmpFather = 0
    upInfoAmpMother = 0
    downInfoAmpMother = 0
    inconclusiveKeyMother = 0
    inconclusiveKeyFather = 0
    directDetection = false
    directDetectionFather = false

    const embryo = data2.preProcessedData.find((e) => e.name === embryoaux.name)

    a1Colors = auxEmbrios?.find(e=> e.name === embryo?.name)?.a1Colors.slice(1, -1).split(',')
    a2Colors = auxEmbrios?.find(e=> e.name === embryo?.name)?.a2Colors.slice(1, -1).split(',')
    
    const res = await firstValueFrom(directDetectionService.getByIndividualID(embryo?.id));
    const embryoDT = res ? res.items : [];



      if (maternalVar.length > 0) {
        const aux1DT = embryoDT.find((edt) => edt.mutationID === maternalVar[0].id)?.directTesting

        if (maternalVar.length > 1) {
          const aux2DT = embryoDT.find((edt) => edt.mutationID === maternalVar[1]?.id)?.directTesting

          directDetection =
            aux1DT && aux1DT !== DirectTestingStatus.Status &&
            aux1DT && aux1DT !== DirectTestingStatus.Inconclusive &&
            aux2DT && aux2DT !== DirectTestingStatus.Status &&
            aux2DT && aux2DT !== DirectTestingStatus.Inconclusive
        } else {


          
          directDetection =
            aux1DT && aux1DT !== DirectTestingStatus.Status && aux1DT !== DirectTestingStatus.Inconclusive
        }

        for (const v of maternalVar){
          if (v.type === 'SNP') {
            if (max < v.position) max = v.position
            if (min > v.position || min === 0) min = v.position
          } else {
            if (max < v.end) max = v.end
            if (min > v.start || min === 0) min = v.start
          }
        }
      } else {
        min = project?.firstGene
        max = project?.lastGene
      }

      if (paternalVar.length > 0) {
        const aux1DT = embryoDT.find((edt) => edt.mutationID === paternalVar[0].id)?.directTesting

        if (paternalVar.length > 1) {
          const aux2DT = embryoDT.find((edt) => edt.mutationID === paternalVar[1]?.id)?.directTesting

          directDetectionFather =
            aux1DT && aux1DT !== DirectTestingStatus.Status &&
            aux1DT && aux1DT !== DirectTestingStatus.Inconclusive &&
            aux2DT && aux2DT !== DirectTestingStatus.Status &&
            aux2DT && aux2DT !== DirectTestingStatus.Inconclusive
        } else {
          directDetectionFather =
            aux1DT && aux1DT !== DirectTestingStatus.Status && aux1DT !== DirectTestingStatus.Inconclusive 
        }
        for (const v of paternalVar){
          if (v.type === 'SNP') {
            if (max2 < v.position) max2 = v.position
            if (min2 > v.position || min2 === 0) min2 = v.position
          } else {
            if (max2 < v.end) max2 = v.end
            if (min2 > v.start || min2 === 0) min2 = v.start
          }
        }
      } else {
        min2 = project?.firstGene
        max2 = project?.lastGene
      }

      let informativityFilter = filterResult(data2.resultTableData)
      const [recomPositionA1, recomPositionA2] = getRecomPosition(
        informativityFilter,
        a1Colors,
        a2Colors,
        embryo,
        min - RECOMBINATION_FLANK,
        max + RECOMBINATION_FLANK,
        min2 - RECOMBINATION_FLANK,
        max2 + RECOMBINATION_FLANK
      )

      console.log("RECOMS")
      console.log("INI", )
      console.log("RECOMS")

      for (const result of informativityFilter){
        let index = informativityFilter?.findIndex((r) => r === result)
        
        let upEmbryo: any
        let downEmbryo:  any
        let embryoResult = informativityFilter[index].individual.find((r) => r.name === embryo?.name)

        let x = 1
        do{
 // Buscar vecino superior
    if (!upEmbryo && index - x >= 0) {
      const upAux = informativityFilter[index - x].individual.find(
        (r) => r.name === embryo?.name
      )
      if (upAux?.a1.word !== "-" && upAux?.a2.word !== "-") {
        upEmbryo = upAux
      }
    }

    // Buscar vecino inferior
    if (!downEmbryo && index + x < informativityFilter.length) {
      const downAux = informativityFilter[index + x].individual.find(
        (r) => r.name === embryo?.name
      )
      if (downAux?.a1.word !== "-" && downAux?.a2.word !== "-") {
        downEmbryo = downAux
      }
    }

    x++
        } while (  !upEmbryo &&
    !downEmbryo &&
    (index - x >= 0 || index + x < informativityFilter.length))
        
  
        if (result.position < min && result.individualType === 'mother_info') {
          if (validColors.includes(embryoResult?.a1.color)) upInfoAmpMother++
          if (
            (props?.project?.pathology !== 'X-Linked' &&
              embryoResult?.a1.key &&
              validColors.includes(embryoResult?.a1.color) &&
              (embryoResult?.a2.color !== '#ddeafb'
                ? (validColors.includes(embryoResult?.a2.color) ||  embryoResult?.a2.color === "#ff7b54")
                : true)) ||
            (props?.project?.pathology === 'X-Linked' &&
              embryoResult?.a1.key &&
            (  validColors.includes(embryoResult?.a1.color) || embryoResult?.a2.color === "#ff7b54"))
          ) if(embryo?.a1ColumnName !== 'P1' ||  a1Colors.length > 1) {
            
              if (embryoResult?.a1.key && 
                validColors.includes(embryoResult?.a1.color) &&
                upEmbryo && downEmbryo &&
                 embryoResult.a1.color  !== downEmbryo.a1.color &&  
                embryoResult.a1.color !== upEmbryo.a1.color)   {

                inconclusiveKeyMother++}
                else if(embryoResult?.a1.key){
                  
                 if (a1Colors[0] === embryoResult?.a1.color) upMother++
                 if (a1Colors[1] === embryoResult?.a1.color) upMotherC2++

                }
            } else if (embryo?.a1ColumnName === 'P1' ) {
              if (
                (a1Colors[0] !== embryoResult?.a1.color && validColors.includes(embryoResult?.a1.color)) &&
                embryoResult?.a1.key ) {

                inconclusiveKeyMother++}
              else if (embryoResult?.a1.key && a1Colors[0] === embryoResult?.a1.color) {
                 upMother++
                upMotherC2++
              }
            }
        }

        if (result.position < min2 && result.individualType === 'father_info') {
          if (validColors.includes(embryoResult?.a2.color)) upInfoAmpFather++
          if (
            (props?.project?.pathology !== 'X-Linked' &&
              embryoResult?.a2.key &&
              (embryoResult?.a1.color !== '#ddeafb'
                ? validColors.includes(embryoResult?.a1.color)
                : true) &&
              validColors.includes(embryoResult?.a2.color)) ||
            (props?.project?.pathology === 'X-Linked' &&
              embryoResult?.a2.key &&
              (validColors.includes(embryoResult?.a1.color) || embryoResult?.a1.color === "#ff7b54"))
          )if(embryo?.a2ColumnName !== 'P2') {

             if (embryoResult?.a2.key && 
                validColors.includes(embryoResult?.a2.color) &&
                upEmbryo && downEmbryo &&
                 embryoResult.a2.color  !== downEmbryo.a2.color &&  // Vecinos iguales
                embryoResult.a2.color !== upEmbryo.a2.color)  {
                  
                  inconclusiveKeyFather++
              }
              else if(embryoResult?.a2.key){
                 if (a2Colors[0] === embryoResult?.a2.color) upFather++
                 if (a2Colors[1] === embryoResult?.a2.color) upFatherC2++
              }
              
            } else if (embryo?.a2ColumnName === 'P2') {
              if (
                ((a2Colors[0] !== embryoResult?.a2.color ) && validColors.includes(embryoResult?.a2.color)) &&
                embryoResult?.a2.key ) {
                  
                  inconclusiveKeyFather++

                }
                  else if(embryoResult?.a2.key && a2Colors[0] === embryoResult?.a2.color){                   
                    upFather++
                  upFatherC2++
              }
            }
        }
        if (
          result.position >= min &&
          result.position <= max &&
          result.individualType === 'mother_info'
        ) {
          if (
            (props?.project?.pathology !== 'X-Linked' &&
              embryoResult?.a1.key &&
              validColors.includes(embryoResult?.a1.color) &&
              (embryoResult?.a2.color !== '#ddeafb'
                ? validColors.includes(embryoResult?.a2.color)
                : true)) ||
            (props?.project?.pathology === 'X-Linked' &&
              embryoResult?.a1.key &&
              validColors.includes(embryoResult?.a1.color))
          )
            inMother++
        }
        if (
          result.position >= min2 &&
          result.position <= max2 &&
          result.individualType === 'father_info'
        ) {
          if (
            embryoResult?.a2.key &&
            (embryoResult?.a1.color !== '#ddeafb'
              ? validColors.includes(embryoResult?.a1.color)
              : true) &&
            validColors.includes(embryoResult?.a2.color)
          )
            inFather++
        }
        if (result.position > max && result.individualType === 'mother_info') {
          if (validColors.includes(embryoResult?.a1.color)) downInfoAmpMother++
          if (
            (props?.project?.pathology !== 'X-Linked' &&
              validColors.includes(embryoResult?.a1.color) &&
              (embryoResult?.a2.color !== '#ddeafb'
                ?( validColors.includes(embryoResult?.a2.color) || embryoResult?.a2.color === "#ff7b54")
                : true)) ||
            (props?.project?.pathology === 'X-Linked' &&
              embryoResult?.a1.key &&
              validColors.includes(embryoResult?.a1.color))
          )  if(embryo?.a1ColumnName !== 'P1' || a1Colors.length>1) {



            if(embryoResult?.a1.key && 
                validColors.includes(embryoResult?.a1.color) &&
                upEmbryo && downEmbryo &&
                 embryoResult.a1.color  !== downEmbryo.a1.color &&  // Vecinos iguales
                embryoResult.a1.color !== upEmbryo.a1.color) {

                inconclusiveKeyMother++
              
              } else if(embryoResult?.a1.key) {
                  if (a1Colors[0] === embryoResult?.a1.color) downMother++
                 if (a1Colors[1] === embryoResult?.a1.color) downMotherC2++

              }
            } else if (embryo?.a1ColumnName === 'P1') {
              if (
                (a1Colors[0] !== embryoResult?.a1.color && validColors.includes(embryoResult?.a1.color)) &&
                embryoResult?.a1.key ) {

                inconclusiveKeyMother++}
              else if (embryoResult?.a1.key && a1Colors[0] === embryoResult?.a1.color){
                   downMother++
                  downMotherC2++
              }
            }
        }
        if (result.position > max2 && result.individualType === 'father_info') {
          if (validColors.includes(embryoResult?.a2.color)){
            downInfoAmpFather++
          }
          if (
            (props?.project?.pathology !== 'X-Linked' &&
              embryoResult?.a2.key &&
              (embryoResult?.a1.color !== '#ddeafb'
                ? (validColors.includes(embryoResult?.a1.color) || embryoResult?.a1.color === "#ff7b54")
                : true) &&
              validColors.includes(embryoResult?.a2.color)) ||
            (props?.project?.pathology === 'X-Linked' &&
              embryoResult?.a2.key &&
              (validColors.includes(embryoResult?.a1.color) || embryoResult?.a1.color === "#ff7b54"))
          )
            if(embryo?.a2ColumnName !== 'P2') {


             if (embryoResult?.a2.key && 
                validColors.includes(embryoResult?.a2.color) &&
                upEmbryo && downEmbryo &&
                 embryoResult.a2.color  !== downEmbryo.a2.color &&  // Vecinos iguales
                embryoResult.a2.color !== upEmbryo.a2.color)   {

                inconclusiveKeyFather++


              } else if(embryoResult?.a2.key)  {
                if (a2Colors[0] === embryoResult?.a2.color) downFather++

                 if (a2Colors[1] === embryoResult?.a2.color) downFatherC2++
                }
            } else if (embryo?.a2ColumnName === 'P2') {
              if (
                (a2Colors[0] !== embryoResult?.a2.color && validColors.includes(embryoResult?.a2.color)) &&
                embryoResult?.a2.key ) {

                inconclusiveKeyFather++}
              else if (embryoResult?.a2.key && a2Colors[0] === embryoResult?.a2.color){
                downFather++
                 downFatherC2++
                }
              
            }

        }
      }
      
      if (maternalVar.length !== 0 && recomPositionA1 !== 0){

        

          if (maternalVar[0].type === 'SNP'){
            if (maternalVar[0].position >= recomPositionA1 ) {
              upMother = upMotherC2
              downMother = downMotherC2
           }
          } else {

            console.log("COUNTS")
            console.log("C1", upMother)
            console.log("C2", upMotherC2)
            console.log(recomPositionA1)
            if (maternalVar[0].start >= recomPositionA1 ) {

              upMother = upMotherC2
              downMother = downMotherC2
           }
           }
      }

        if (paternalVar.length !== 0 && recomPositionA2 !== 0){

          if (paternalVar[0].type === 'SNP'){
            if (paternalVar[0].position >= recomPositionA2 ) {
              upFather = upFatherC2
              downFather = downFatherC2
           }
          } else {
            if (paternalVar[0].start >= recomPositionA2 ) {

              upFather = upFatherC2
              downFather = downFatherC2
           }
           }  
      }

      let [valueMother, infoMother] = confidenceLevelEmbryoInfo(
        'p1',
        upMother,
        downMother,
        upInfoAmpMother,
        downInfoAmpMother,
        directDetection
      )
      let [valueFather, infoFather] = confidenceLevelEmbryoInfo(
        'p2',
        upFather,
        downFather,
        upInfoAmpFather,
        downInfoAmpFather,
        directDetectionFather
      )
      let kpForBothMother: boolean = false
      let kpForBothFather: boolean = false
      let motherInconclusive: boolean = false
      let fatherInconclusive: boolean = false



        if ((inconclusiveKeyFather >= 2 && valueFather <= 4) || (valueMother <= 4 && inconclusiveKeyMother >= 2)) {

            embryoService.getByID(embryo?.id).subscribe(res=>{
              let toUpdate = res.toDTO()
              let columnsNames = data2.preProcessedData.find(e=> e.name === toUpdate.name)
              toUpdate.inconclusive = true
              toUpdate.a1ColumnName = columnsNames.a1ColumnName
              toUpdate.a2ColumnName = columnsNames.a2ColumnName

              
              embryoService.update(toUpdate).subscribe(res2=>{
                let aux = [...embryos];
                let found = aux.find(a => a.name === res2.name);
                if (found) {
                  found.inconclusive = true;
                }


                props.setEmbryos(aux)
                setEmbryos(aux);
            })

          })

        if (inconclusiveKeyFather >= 2 && valueFather <= 4 ) {
          fatherInconclusive = true
        }

        if (inconclusiveKeyMother >= 2 && valueMother <= 4) { 
          motherInconclusive=true
        }
      } else {


            embryoService.getByID(embryo?.id).subscribe(res=>{
              
              let toUpdate = res.toDTO()
              let columnsNames = data2.preProcessedData.find(e=> e.name === toUpdate.name)
              toUpdate.inconclusive = false
              toUpdate.a1ColumnName = columnsNames.a1ColumnName
              toUpdate.a2ColumnName = columnsNames.a2ColumnName
              
              embryoService.update(toUpdate).subscribe(res2=>{
                let aux = [...embryos];
                let found = aux.find(a => a.name === res2.name);
                if (found) {
                  found.inconclusive = false;
                }
                props.setEmbryos(aux)
                setEmbryos(aux);

            })

          })

          if ((inconclusiveKeyFather >= 2 && valueFather > 4) || inconclusiveKeyFather <2 ) {
            fatherInconclusive = false
          }

          if ((inconclusiveKeyMother >= 2 && valueMother > 4) || inconclusiveKeyMother < 2) { 
            motherInconclusive=false
          }
          
        }

        if (inconclusiveKeyFather >= 2) {
          kpForBothFather = true
        }
        if (inconclusiveKeyMother >= 2) {
          kpForBothMother = true
        }
      

      auxMother.push({
        upInfo: upMother,
        inInfo: inMother,
        downInfo: downMother,
        levelConfidence: {
          level: valueMother,
          Information: infoMother,
          color: confidenceColor(valueMother),
        },
        validated: embryo?.validatedMaternal,
        kpForBoth: kpForBothMother,
        inconclusive: motherInconclusive
      })

      auxFather.push({
        upInfo: upFather,
        inInfo: inFather,
        downInfo: downFather,
        levelConfidence: {
          level: valueFather,
          Information: infoFather,
          color: confidenceColor(valueFather),
        },
        validated: embryo?.validatedPaternal,
        kpForBoth: kpForBothFather,
        inconclusive: fatherInconclusive
      })

   
    }
    setEmbryosConfMoth(auxMother)

    setEmbryosConfFath(auxFather)
  }

  useEffect(() => {
    if (embryos.length > 0) handleEmbryoIndo()
  }, [ maternalVar, paternalVar])

  useEffect(() => {
    let auxMaternalVar: MutationsPosition[] = []
    let auxPaternalVar: MutationsPosition[] = []
    mutationService.getByProjectID(project?.mutationPositionsID || '').subscribe((resV) => {
      if (resV) {
        resV.items.map((variant) => {
          if (variant.paternal === 'mother') auxMaternalVar.push(variant)
          if (variant.paternal === 'father') auxPaternalVar.push(variant)
        })
      }

      if(auxMaternalVar.length !== 0)setMaternalVar(auxMaternalVar)
      if(auxPaternalVar.length !== 0)setPaternalVar(auxPaternalVar)
      disableOption()
    })
  }, [testData])

  const subtractLight = function (color: any, amount: any) {
    let cc = parseInt(color, 16) - amount
    let c = cc < 0 ? 0 : cc
    //@ts-ignore
    c = c.toString(16)?.length > 1 ? c.toString(16) : `0${c.toString(16)}`
    return c
  }

  const darken = (color: any, amount: any) => {
    color = color.indexOf('#') >= 0 ? color.substring(1, color?.length) : color
    //@ts-ignore
    amount = parseInt((255 * amount) / 100)
    return (color = `#${subtractLight(color?.substring(0, 2), amount)}${subtractLight(
      color.substring(2, 4),
      amount
    )}${subtractLight(color.substring(4, 6), amount)}`)
  }

  const confidenceColor = (level: number): string => {
    switch (level) {
      case 0:
        return '#ee5252'
      case 1:
        return '#e86f4a'
      case 2:
        return '#e39e43'
      case 3:
        return '#ddb73a'
      case 4:
        return '#ebee52'
      case 5:
        return '#c8d64f'
      case 6:
        return '#a3bf4b'
      case 7:
        return '#7fb946'
      case 8:
        return '#57ee52'
      default:
        return '#000000'
    }
  }

  // Computes the current sticky left for the Male column so headers and cells
  // stay aligned across AF/QC toggle combinations and spacing changes
  const getMaleStickyLeft = (): number => {
    const base = qualityCoverage && afOn ? 178 : qualityCoverage || afOn ? 118.2 : 85.5
    // include the inter-column gap applied through margin-left
    return base + 10
  }

  // Helper function to check if a position is a user-defined mutation/variant position
  const isUserDefinedMutationPosition = (position: number): { isMaternalMutation: boolean, isPaternalMutation: boolean } => {
    let isMaternalMutation = false
    let isPaternalMutation = false
    
    // Check maternal variants
    maternalVar?.forEach((variant) => {
      if (variant.type === 'SNP') {
        if (position === variant.position) isMaternalMutation = true
      } else {
        if (position === variant.start || position === variant.end) isMaternalMutation = true
      }
    })
    
    // Check paternal variants
    paternalVar?.forEach((variant) => {
      if (variant.type === 'SNP') {
        if (position === variant.position) isPaternalMutation = true
      } else {
        if (position === variant.start || position === variant.end) isPaternalMutation = true
      }
    })
    
    return { isMaternalMutation, isPaternalMutation }
  }

  const getDataComponentFiltered = (data: any) => {
    const shouldFilterByAllele = Object.values(alleleModes).some(mode => mode !== 'OFF')
    
    // When lowPositions is OFF, hide rows where PARENTS have low-quality alleles.
    // quality <= 20 or coverage <= 10 is considered low.
    // Only check parent individuals (Female/Male), not embryos.
    // User-defined mutation positions should always be visible when their respective parent toggles are active.
    if (!lowPositions) {
      // Check if this position is a user-defined mutation/variant position
      const { isMaternalMutation, isPaternalMutation } = isUserDefinedMutationPosition(data.position)
      
      const shouldPreserve = (isMaternalMutation && motherInfo) || (isPaternalMutation && fatherInfo)
      
      if (!shouldPreserve) {
        // Only check individuals (not embryos) for low quality
        const hasLowQualityOrMissingData = data?.individual?.some((ind: any) => {
          // Skip embryos, only check individuals
          if (ind.role === RolePGDTest.Embryo) {
            return false
          }
          
          return (
            (typeof ind?.quality === 'number' && ind.quality <= 20) ||
            (typeof ind?.coverage === 'number' && ind.coverage <= 10) ||
            (ind?.a1?.word === '-' &&( ind?.a2?.word === '-' ||  ind?.a2?.word === ''))
          )
        })
        if (hasLowQualityOrMissingData) return ''
      }
    }

    if (shouldFilterByAllele) {
      // Check if any column has filtering enabled and this row should be hidden
      for (const [individualName, mode] of Object.entries(alleleModes)) {
        if (mode === 'OFF') continue
        
        // Find the individual data for this column
        const individualData = data.individual?.find((ind: any) => (
          ind?.name === individualName ||
          ind?.sampleName === individualName ||
          ind?.fileName === individualName ||
          String(ind?.role) === individualName ||
          rolePgdTest()[ind?.role] === individualName ||
          Number(individualName) === ind?.role
        ))
        if (!individualData) continue
        
        // Check if P1 and P2 are the same (homozygous) or different (heterozygous)
        const isHomozygous = individualData.a1.word === individualData.a2.word
        
        // Hide row if either allele is missing data ("-")
        if (individualData.a1.word === '-' || individualData.a2.word === '-') {
          return ''
        }
        
        // Hide row if mode doesn't match the zygosity
        if ((mode === 'HET' && isHomozygous) || (mode === 'HOM' && !isHomozygous)) {
          return ''
        }
      }
    }
    
    switch (true) {
      case data?.individualType === 'mother_info' && !motherInfo:
        return ''
      case data?.individualType === 'father_info' && !fatherInfo:
        return ''
      case data?.individualType === 'no_info' && !noInfo:
        return ''
      case data?.individualType === 'semi_info' && !semiInfo:
        return ''
      case data?.individualType === 'both_info' && !fatherInfo && !motherInfo:
        return ''
      case data?.individualType === '':
        return ''
      default:
        return getDataComponent(data, data?.individualType)
    }
  }

  const onPress = (aindex: number, position: number, indexIndividual: number, ind: any) => {
    setAlleleModal(true)
    setCurrentPosition(position)
    setCurrentAIndex(aindex)
    setCurrentIndividual(ind)
  }

  const handleChangeColor = (newColor: string) => {
    let row = data2.resultTableData.filter((r: any) => r.position === currentPosition)

    if (currentAIndex === 1) {
      currentIndividual.a1.color = newColor
    } else {
      currentIndividual.a2.color = newColor
    }

    if (row[0].individualType === 'MutationAdded') {
      setMutationChanges(true)
    } else {
      if (currentAIndex === 1) {
        let wordToPush: WordDTO = {
          id: currentIndividual.a1.id,
          word: currentIndividual.a1.word,
          color: newColor,
          key: currentIndividual.a1.key,
        }

        let array = wordsChanges ? [...wordsChanges] : []
        array.push(wordToPush)
        setWordsChanges(array)
      } else if (currentAIndex === 2) {
        let wordToPush: WordDTO = {
          id: currentIndividual.a2.id,
          word: currentIndividual.a2.word,
          color: newColor,
          key: currentIndividual.a2.key,
        }

        let array = wordsChanges ? [...wordsChanges] : []
        array.push(wordToPush)
        setWordsChanges(array)
      }
      setChanges(true)
    }

    setAlleleModal(false)
    // setShowScrollbar(true)
    setSelectedOption('')
  }

  const allowedChars = new Set(['C', 'T', 'G', 'A'])

  const handleInput = (e: any, aindex: number, indexIndividual: number, ind: any, data: any) => {
    const inputText = e.target.innerText

    if (inputText.length === 1 && allowedChars.has(inputText)) {
      e.target.dataset.valid = 'true'
    } else {
      e.target.innerText = '' // Reset to empty if invalid
      e.target.dataset.valid = 'false'
    }
  }

  const handleKeyDown = (e: any, aindex: number, ind: any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      const inputText = e.target.innerText

      if (e.target.dataset.valid === 'true') {
        updateMutation(aindex, inputText, ind)
        e.target.blur()
      } else {
        e.target.innerText = '' // Reset to empty if invalid
      }
    }
  }

  const updateMutation = (aindex: any, inputText: any, ind: any) => {
    if (aindex === 1) {
      ind.a1.word = inputText
    } else {
      ind.a2.word = inputText
    }

    setMutationChanges(true)
  }

  function filterUniqueRoles(individual: any[]) {
    const uniqueRoles = new Set()
    return individual?.filter((item) => {
      if (!uniqueRoles.has(item.role) || item.role === RolePGDTest.Embryo) {
        uniqueRoles.add(item.role)
        return true
      }
      return false
    })
  }

  function filterUniqueRolesWithoutFemaleAndMale(individual: any[]) {
    const uniqueRoles = new Set()
    return individual?.filter((item) => {
      if (!uniqueRoles.has(item.role) || item.role === RolePGDTest.Embryo) {
        uniqueRoles.add(item.role)
        return true
      }
      return false
    })
  }

  const [selectedMutations, setSelectedMutations] = useState<any[]>([])

  const handleCheckboxChange = (item: any) => {
    setSelectedMutations((prevSelectedItems) => {
      if (prevSelectedItems.find((selectedItem) => selectedItem.position === item.position)) {
        return prevSelectedItems.filter((selectedItem) => selectedItem.position !== item.position)
      } else {
        return [...prevSelectedItems, item]
      }
    })
  }

  const getData = (ind: any, indexIndividual: number, data: any, individualType: string) => {
    if (ind.role === RolePGDTest.Embryo && isEmbryoHidden2(ind.name)) {
      return null
    }

    //Se encarga de ocultar los que tengan rol diferente a Embryo
    if (ind.role !== RolePGDTest.Embryo && isEmbryoHidden3(ind.role)) return null

    return (
      <div
        style={{
          backgroundColor:
            individualType === 'MutationAdded' || individualType === 'MutationMarked'
              ? '#ffffff'
              : '',
          width: qualityCoverage && afOn ? '178px' : qualityCoverage || afOn ? '118.2px' : '85.5px',
          position: 'sticky',
        }}>
        <div className={styles.wordContainer2}>
          <div
            className={
              qualityCoverage && afOn
                ? styles.subContainerAll
                : qualityCoverage || afOn
                ? styles.subContainerQC
                : styles.subContainer
            }>
            <div
              className={styles.a2Word}
              key="a2Word"
              contentEditable={ind.a1.word === ''}
              onInput={(e) => handleInput(e, data?.position, 2, indexIndividual, ind)}
              onKeyDown={(e) => handleKeyDown(e, 1, ind)}
              onClick={() => ind.a1.word && onPress(1, data.position, indexIndividual, ind)}
              style={{
                backgroundColor:
                  individualType === 'MutationAdded'
                    ? ind.a1.color
                      ? ind.a1.color
                      : 'RGB (255, 123, 84)'
                    : ind.a1.key && validColors.includes(ind.a1.color)
                    ? darken(ind.a1.color, 20)
                    : ind.a1.color
                    ? ind.a1.color
                    : '#f0f0f0',
                border: ind.a1.word && `3px solid ${ind.a1.color}`,
                borderRight: ind.a1.word && `3px solid ${ind.a1.color}`,
                cursor: 'pointer',
              }}>
              {ind.a1.word || '\u200B'}
            </div>

            <div
              key="a1Word"
              onClick={() => ind.a2.word && onPress(2, data.position, indexIndividual, ind)}
              className={styles.a2Word}
              contentEditable={ind.a2.word === ''}
              onInput={(e) => handleInput(e, data?.position, 2, indexIndividual, ind)}
              onKeyDown={(e) => handleKeyDown(e, 2, ind)}
              style={{
                height: '24.5px',
                backgroundColor:
                  individualType === 'MutationAdded'
                    ? ind.a2.color
                      ? ind.a2.color
                      : 'RGB (255, 123, 84)'
                    : ind.a2.key && validColors.includes(ind.a2.color)
                    ? darken(ind.a2.color, 20)
                    : ind.a2.color
                    ? ind.a2.color
                    : '#f0f0f0',
                border: ind.a2.word && `3px solid ${ind.a2.color}`,
                borderRight:
                  ind.a2.color !== '#999999'
                    ? ind.a2.word && `3px solid ${ind.a2.color}`
                    : '0.5px solid grey',
                cursor: 'pointer',
                borderLeft: ind.a2.key
                  ? ind.a2.word && `3px solid ${ind.a2.color}`
                  : ind.a2.color && '0.5px solid grey',
              }}>
              {ind.a2.word || '\u200B'}
            </div>
          </div>
          {qualityCoverage && (
            <div className={afOn ? styles.subContainerAll : styles.subContainerQC}>
              <div
                className={styles.quacoR}
                style={{
                  height: '24.5px',
                  backgroundColor: ind.quality > 20 ? 'rgb(182, 197, 204)' : 'rgb(153, 153, 153)',
                  border: `3px solid ${
                    ind.quality > 20 ? 'rgb(182, 197, 204)' : 'rgb(153, 153, 153)'
                  }`,
                  borderLeft: '1px solid grey',
                }}>
                {ind.quality}
              </div>
              <div
                className={styles.quaco}
                style={{
                  backgroundColor: ind.coverage > 10 ? 'rgb(182, 197, 204)' : 'rgb(153, 153, 153)',
                  border: `3px solid ${
                    ind.coverage > 10 ? 'rgb(182, 197, 204)' : 'rgb(153, 153, 153)'
                  }`,
                  borderLeft: '1px solid grey',
                }}>
                {ind.coverage}
              </div>
            </div>
          )}
          {afOn && (
            <div className={qualityCoverage ? styles.subContainerAll : styles.subContainerQC}>
              <div className={styles.alFreq} style={{
                  backgroundColor: 'rgb(182, 197, 204)',
                  border: '3px soli rgb(182, 197, 204)',
                  fontSize: '9px',
                  borderLeft: '1px solid grey',
                }}>
                {ind.a1Frequency.toFixed(2)}
              </div>
              <div
                className={styles.alFreq}
                style={{
                  backgroundColor: 'rgb(182, 197, 204)',
                  border: '3px soli rgb(182, 197, 204)',
                  fontSize: '9px',
                  borderLeft: '1px solid grey',
                }}>
                {ind.a2Frequency.toFixed(2)}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  const checkAffected = (embryo: Embryo, finalSt: FinalStatus) => {
    return finalStatusTitle()[
      (project?.pathology === 'X-Linked' &&
        embryo?.embryoGender === 'male' &&
        finalSt === FinalStatus.CarrierFromMother) ||
      (project?.pathology === 'Dominant' &&
        (finalSt === FinalStatus.CarrierFromFather || finalSt === FinalStatus.CarrierFromMother))
        ? FinalStatus.Affected
        : finalSt
        
    ]
  }

  const recombinantStatus = (embryo: Embryo, finalSt: FinalStatus) => {
    const finded = data2.preProcessedData.find((e) => e.name === embryo?.name)

      const male = data2.preProcessedData.find((i)=> i.role === RolePGDTest.Male)
      const female = data2.preProcessedData.find((i)=> i.role === RolePGDTest.Female)

      if (finded?.a1ColumnName === 'LR' || finded?.a2ColumnName === 'LR') {
        return "Likely Recombinant"
      } 
        
      if (finded?.a1ColumnName === 'LRCM') {
        if (male.finalStatus === FinalStatus.Affected || 
          (male.finalStatus === FinalStatus.CarrierFromFather && finded.a2Colors[0] === '#09d6e8')||
         (male.finalStatus === FinalStatus.CarrierFromMother && finded.a2Colors[0] === '#e8d863')) {
            return "Likely recombinant, but seems to be Affected"
        } else {
             return project?.pathology === "Dominant" || (project?.pathology === "X-Linked" && embryo.embryoGender === "male") 
              ? "Likely recombinant, but seems to be Affected" 
              : "Likely recombinant, but seems to be Carrier from Mother"
        }
      }

      if (finded?.a1ColumnName === 'LRNC') {
        if ( (male.finalStatus === FinalStatus.CarrierFromFather && finded.a2Colors[0] === '#09d6e8')||
         (male.finalStatus === FinalStatus.CarrierFromMother && finded.a2Colors[0] === '#e8d863')) {
            return project?.pathology === "Dominant" 
              ? "Likely recombinant, but seems to be Affected" 
              : "Likely recombinant, but seems to be Carrier from Father"
        } else return "Likely recombinant, but seems to be Non-Carrier" 
      }


      if (finded?.a2ColumnName === 'LRCF') {
        if (female?.finalStatus === FinalStatus.Affected || 
          (female?.finalStatus === FinalStatus?.CarrierFromFather && finded?.a1Colors[0] === '#03de6c')||
         (female?.finalStatus === FinalStatus?.CarrierFromMother && finded?.a1Colors[0] === '#ed6afa')) {
            return "Likely recombinant, but seems to be Affected"
        } else {
             return project?.pathology === "Dominant" 
              ? "Likely recombinant, but seems to be Affected" 
              : "Likely recombinant, but seems to be Carrier from Father"
        }
      }

      if (finded?.a2ColumnName === 'LRNC') {
        
      if (female?.finalStatus === FinalStatus.Affected || 
          (female?.finalStatus === FinalStatus?.CarrierFromFather && finded?.a1Colors[0] === '#03de6c')||
         (female?.finalStatus === FinalStatus?.CarrierFromMother && finded?.a1Colors[0] === '#ed6afa')){

            return (project?.pathology === "Dominant" || (project?.pathology === "X-Linked" && embryo.embryoGender === "male") )
              ? "Likely recombinant, but seems to be Affected" 
              : "Likely recombinant, but seems to be Carrier from Mother"
        } else return "Likely recombinant, but seems to be Non-Carrier" 
      } 

  }

  const getFirstEmbryo = (emb) => {
    return data2.preProcessedData?.findIndex(i=>i?.role === RolePGDTest.Embryo )
  }

  const getDataComponent = (data, individualType) => {
    return (
      <div
        className={
          selectedMutations.find((item) => item.position === data.position) || data.isVariant
            ? styles.dataContainerCondition
            : styles.dataContainer
        }>
        <Checkbox
          size="small"
          className={styles.checkbox}
          disabled={data.isVariant}
          checked={
            data.isVariant ||
            selectedMutations.find((selectedItem) => selectedItem.position === data.position)
          }
          onChange={() => handleCheckboxChange(data)}
        />
        <div className={styles.dataContainer2}>
          <div className={styles.dataContainer5}>
            <div className={styles.chromDiv2}>{data.chromosoma}</div>
            <div className={styles.dataContainerBorder} />
            <div 
              className={styles.posDiv2}
              onClick={() => handlePositionClick(data)}
              style={{ cursor: igvEnabled ? 'pointer' : 'default' }}
            >
              {data.position}
            </div>
          </div>
        </div>
        {
        filterUniqueRolesWithoutFemaleAndMale(data.individual)
          ?.sort((a, b) => {
            if (a.role === b.role) {
              return a.embryo - b.embryo
            } else return customOrder[a.role] - customOrder[b.role]
          })
          ?.map((ind, indexIndividual) => (
            <div
              className={
                ind.role === RolePGDTest.Female
                  ? isEmbryoHidden3(ind.role)
                    ? styles.fixed1Hiden
                    : styles.fixed1
                  : ind.role === RolePGDTest.Male
                  ? qualityCoverage && afOn
                    ? isEmbryoHidden3(ind.role)
                      ? styles.fixed2WithAllHiden
                      : styles.fixed2WithAll
                    : qualityCoverage || afOn
                    ? isEmbryoHidden3(ind.role)
                      ? styles.fixed2WithQualityCoverageHiden
                      : styles.fixed2WithQualityCoverage
                    : isEmbryoHidden3(ind.role)
                    ? styles.fixed2Hiden
                    : styles.fixed2
                  : ind.role !== RolePGDTest.Embryo
                  ? isEmbryoHidden3(ind.role)
                    ? styles.withoutSpacesHiden
                    : styles.withoutSpaces
                  : isEmbryoHidden2(ind.name)
                  ? styles.withoutSpacesHiden
                  : `${styles.withoutSpaces} ${
                   ind.role === RolePGDTest.Embryo && getFirstEmbryo(ind) === indexIndividual
                        ? styles['embryo-separator']
                        : ''
                    }`
              }
              style={{ backgroundColor: data.isVariant ? 'wheat' : 'white' }}
              key={indexIndividual}>
              {getData(ind, indexIndividual, data, individualType)}
            </div>
          ))}
      </div>
    )
  }

  const validateInfo = (valid: boolean, individual: RolePGDTest) => {
    let individualsAux = individuals
    let individualsIndex = individuals?.findIndex((indi) => indi.individual === individual)

    individualsAux[individualsIndex].validated = valid
    individual === RolePGDTest.Female ? setMotherValidated(valid) : setFatherValidated(valid)

    individualService.update2(individualsAux[individualsIndex]?.toDTO()).subscribe((res) => {})
  }

  const validateInfoEmbryo = (allele: string, valid: boolean, index: number) => {
    let embryosAux = embryos
    if (allele === 'p1') {
      let infoAux = [...embryosConfMoth]
      infoAux[index].validated = valid
      embryosAux[index].validatedMaternal = valid

      setEmbryosConfMoth(infoAux)
    } else {
      let infoAux = [...embryosConfFath]
      infoAux[index].validated = valid
      embryosAux[index].validatedPaternal = valid

      setEmbryosConfFath(infoAux)
    }

    setEmbryos(embryosAux)

    embryoService.update(embryosAux[index]?.toDTO()).subscribe((res) => {})
  }


useEffect(() => {
  handleParentsConfidenceLevel()
}, [paternalVar, maternalVar, paternalDirect, maternalDirect])

// Efecto separado, solo hace fetch una vez por individuo
const [maternalDirectFetched, setMaternalDirectFetched] = useState(false)

useEffect(() => {
  const maternalIndi = individuals.find((ind) => ind.individual === Individuals.FEMALE)
  if (!maternalDirectFetched && maternalIndi?.id) {
    directDetectionService.getByIndividualID(maternalIndi.id).subscribe((res) => {
      setMaternalDirect(res?.items ?? [])
      setMaternalDirectFetched(true)
    })
  }
}, [maternalDirectFetched])

// Función de validación corregida: usa maternalDirect, no paternalDirect
const isValidMaternalDirectTesting = (mutationID: string | undefined): boolean => {
  const found = maternalDirect?.find((md) => md.mutationID === mutationID)
  if (!found) return false
  return (
    found.directTesting !== DirectTestingStatus.Inconclusive &&
    found.directTesting !== DirectTestingStatus.Status
  )
}

// Efecto de cálculo de confianza, sin lógica de fetch dentro
useEffect(() => {
  let directDetection = false
  let directDetection2: boolean = null

  if (maternalVar.length > 1) {
    if (maternalVar[0].trans || maternalVar[1].trans) {
      if (maternalVar[0].trans) {
        directDetection = isValidMaternalDirectTesting(maternalVar[1]?.id)
        directDetection2 = isValidMaternalDirectTesting(paternalVar[0]?.id)
      } else {
        directDetection2 = isValidMaternalDirectTesting(maternalVar[1]?.id)
        directDetection = isValidMaternalDirectTesting(maternalVar[0]?.id)
      }
    } else {
      directDetection =
        isValidMaternalDirectTesting(maternalVar[1]?.id) &&
        isValidMaternalDirectTesting(maternalVar[0]?.id)
    }
  } else {
    directDetection = isValidMaternalDirectTesting(maternalVar[0]?.id)
  }

  const fStatus = data2?.preProcessedData?.find(
    (ind) => ind.role === RolePGDTest.Female
  )?.finalStatus

  const [level, info] = confidenceLevel(
    upVari, downVari, upVari2, downVari2,
    directDetection, fStatus, 'maternal', directDetection2
  )
  setConfidenceMotherRange({ level, Information: info, color: confidenceColor(level) })
}, [upVari, downVari, upVari2, downVari2, maternalDirect])


const isValidDirectTesting = (mutationID: string | undefined): boolean => {
  const found = paternalDirect?.find((md) => md.mutationID === mutationID)
  if (!found) return false
  return (
    found.directTesting !== DirectTestingStatus.Inconclusive &&
    found.directTesting !== DirectTestingStatus.Status
  )
}


const [paternalDirectFetched, setPaternalDirectFetched] = useState(false)

useEffect(() => {
  const paternalIndi = individuals.find((ind) => ind.individual === Individuals.MALE)
  if (!paternalDirectFetched && paternalIndi?.id) {
    directDetectionService.getByIndividualID(paternalIndi.id).subscribe((res) => {
      setPaternalDirect(res?.items ?? [])
      setPaternalDirectFetched(true)
    })
  }
}, [paternalDirectFetched])


useEffect(() => {
  const paternalIndi = individuals.find((ind) => ind.individual === Individuals.MALE)
  let directDetection = false
  let directDetection2: boolean = null

  if (paternalVar.length > 1) {
    console.log("llega a entrar")
    if (paternalVar[0].trans || paternalVar[1].trans) {
      if (paternalVar[0].trans) {
        directDetection = isValidDirectTesting(paternalVar[1]?.id)
        directDetection2 = isValidDirectTesting(paternalVar[0]?.id)
      } else {
        directDetection2 = isValidDirectTesting(paternalVar[1]?.id)
        directDetection = isValidDirectTesting(paternalVar[0]?.id)
      }
    } else {
      directDetection =
        isValidDirectTesting(paternalVar[1]?.id) &&
        isValidDirectTesting(paternalVar[0]?.id)
    }
  } else {
    directDetection = isValidDirectTesting(paternalVar[0]?.id)
  }

  const fStatus = data2?.preProcessedData?.find(
    (ind) => ind.role === RolePGDTest.Male
  )?.finalStatus

  const [level, info] = confidenceLevel(
    upVariFather, downVariFather, upVari2Father, downVari2Father,
    directDetection, fStatus, 'paternal', directDetection2
  )
  console.log(directDetection)
  setConfidenceFatherRange({ level, Information: info, color: confidenceColor(level) })
}, [upVariFather, upVari2Father, downVariFather, downVari2Father, paternalDirect, paternalVar])

  useEffect(() => {
    if (props.embryos) {
      const emb = []

      filterUniqueRoles(data2?.preProcessedData)
        ?.sort((a, b) => customOrder[a.role] - customOrder[b.role])
        ?.forEach((data) => {
          props.embryos?.forEach((e) => {
            
            if (data.name === e.name) emb.push(e)
          })
        })
      setEmbryos(emb.sort((a, b) => a.embryo - b.embryo))
    }
  }, [props.embryos])

  useEffect(() => {
    if (!props.project) return
    const informativityID = props.project?.informativityID || ''
    const embryosGroupID = props.project?.embryosGroupID || ''

    let cancelled = false

    Promise.all([
      individualService.getFilteredList(new Query({ query: [new QueryParam('informativityID', informativityID)]})).toPromise?.() ||
      new Promise((resolve) => individualService.getFilteredList(new Query({ query: [new QueryParam('informativityID', informativityID)]})).subscribe(resolve as any)),
      embryoService.getFilteredList(new Query({ query: [new QueryParam('embryosGroupID', embryosGroupID)]})).toPromise?.() ||
      new Promise((resolve) => embryoService.getFilteredList(new Query({ query: [new QueryParam('embryosGroupID', embryosGroupID)]})).subscribe(resolve as any))
    ]).then((results: any[]) => {
      if (cancelled) return
      const indiRes = results[0]
      const embRes = results[1]
      const okIndi = indiRes?.items?.some((i: any) => i?.bimFileID && i?.baiFileID)
      const okEmb = embRes?.items?.some((e: any) => e?.bimFileID && e?.baiFileID)
      setHasIgvTracks(Boolean(okIndi || okEmb))
    })

    return () => { cancelled = true }
  }, [props.project])

  const checkLR = (embryo: Embryo) => {
    const finded = data2.preProcessedData.find((e) => e.name === embryo?.name)
    if (!finded) {
      return false
    }

    return finded?.a1ColumnName !== 'P1' || finded?.a2ColumnName !== 'P2'
  }

  // Helper function to check if a position should be counted in KP calculations
  // Low-quality positions (quality ≤ 20 or coverage ≤ 10) are NEVER counted,
  // regardless of the LOW POSITIONS toggle state
  const shouldCountPosition = (data: any): boolean => {
    // Check if this position is a user-defined mutation/variant position
    const { isMaternalMutation, isPaternalMutation } = isUserDefinedMutationPosition(data.position)
    const shouldPreserve = (isMaternalMutation && motherInfo) || (isPaternalMutation && fatherInfo)
    
    // User-defined mutations are always counted (even if they have low quality)
    if (shouldPreserve) {
      return true
    }
    
    // Check if any Individual (not embryos) has low quality/coverage
    const hasLowQuality = data?.individual?.some((ind: any) => {
      // Only check individuals, skip embryos
      if (ind.role === RolePGDTest.Embryo) {
        return false
      }
      
      return (
        (typeof ind?.quality === 'number' && ind.quality <= 20) ||
        (typeof ind?.coverage === 'number' && ind.coverage <= 10)
      )
    })
    
    return !hasLowQuality
  }


interface Bounds {
  min: number
  max: number
}

interface VariantCounts {
  up: number
  in: number
  down: number
  up2: number
  in2: number
  down2: number
}


const getVariantBounds = (variants: Variant[]): Bounds => {
  let min = 0, max = 0
  variants.forEach((variant) => {
    const start = variant.type === 'SNP' ? variant.position : variant.start
    const end   = variant.type === 'SNP' ? variant.position : variant.end
    if (end > max) max = end
    if (start < min || min === 0) min = start
  })
  return { min, max }
}

const getBoundsForAffected = (
  variants: Variant[]
): { bounds: Bounds; bounds2: Bounds } => {
  if (variants.length > 1) {
    const [v0, v1] = variants
    if (v0.trans && v0.type !== 'SNP') {
      return {
        bounds:  { min: v1.start, max: v1.end },
        bounds2: { min: v0.start, max: v0.end },
      }
    }
    if (v1.trans && v1.type !== 'SNP') {
      return {
        bounds:  { min: v0.start, max: v0.end },
        bounds2: { min: v1.start, max: v1.end },
      }
    }
  }
  return {
    bounds:  { min: variants[0]?.start, max: variants[0]?.end },
    bounds2: { min: variants[0]?.start, max: variants[0]?.end },
  }
}

const countByPosition = (
  rows: ResultRow[],
  role: RolePGDTest,
  individualType: string,
  bounds: Bounds,
  bounds2?: Bounds
): VariantCounts => {
  const counts: VariantCounts = { up: 0, in: 0, down: 0, up2: 0, in2: 0, down2: 0 }
  const b2 = bounds2 ?? bounds

  rows.forEach((data) => {
    if (!shouldCountPosition(data)) return
    if (individualType && data.individualType !== individualType) return

    const aux = data.individual.find((i) => i.role === role)
    if (!aux) return

    const colorsValid =
      validColors.includes(aux.a1.color) && validColors.includes(aux.a2.color)

    if (aux.a1.key && colorsValid) {
      if (data.position < bounds.min) counts.up++
      if (data.position > bounds.max) counts.down++
    }
    if (aux.a2.key && colorsValid) {
      if (data.position < b2.min) counts.up2++
      if (data.position > b2.max) counts.down2++
    }
  })

  return counts
}

const computeNoPanelCounts = (
  role: RolePGDTest,
  individualType: string
): VariantCounts => {
  const rows = data2.resultTableData ?? []
  const counts: VariantCounts = { up: 0, in: 0, down: 0, up2: 0, in2: 0, down2: 0 }

  if (testData?.Panel?.genRegion !== 'Gene') {
    rows.forEach((data) => {
      if (!shouldCountPosition(data)) return
      const aux = data.individual.find((i) => i.role === role)
      if (!aux) return
      if (aux.a1.key) counts.up++
      if (aux.a2.key) counts.up2++
    })
    return counts
  }

  rows.forEach((data) => {
    if (!shouldCountPosition(data)) return
    if (data.individualType !== individualType) return

    const aux = data.individual.find((i) => i.role === role)
    if (!aux) return

    const colorsValid =
      validColors.includes(aux.a1.color) && validColors.includes(aux.a2.color)

    if (data.position < testData.Panel.start) {
      if (aux.a1.key && colorsValid) counts.up++
      if (aux.a2.key && colorsValid) counts.up2++
    } else if (
      data.position > testData.Panel.start &&
      data.position < testData.Panel.end
    ) {
      if (aux.a1.key && colorsValid) counts.in++
      if (aux.a2.key && colorsValid) counts.in2++
    } else if (data.position > testData.Panel.end) {
      if (aux.a1.key && colorsValid) counts.down++
      if (aux.a2.key && colorsValid) counts.down2++
    }
  })

  return counts
}

const computeParentCounts = (
  role: RolePGDTest,
  individualType: 'mother_info' | 'father_info',
  variants: Variant[],
  indiStatus?: Status | FinalStatus
): VariantCounts => {
  const rows = data2.resultTableData ?? []
  const empty: VariantCounts = { up: 0, in: 0, down: 0, up2: 0, in2: 0, down2: 0 }

  if (individuals?.length === 2) {
    if (variants.length > 0) {
      const { min, max } = getVariantBounds(variants)
      return {
        ...empty,
        up:   rows.filter((d) => shouldCountPosition(d) && d.position < min && d.individualType === individualType).length,
        down: rows.filter((d) => shouldCountPosition(d) && d.position > max && d.individualType === individualType).length,
      }
    }
    return {
      ...empty,
      up: rows.filter((d) => shouldCountPosition(d) && d.individualType === individualType).length,
    }
  }

  if (variants.length > 0) {
    const isAffectedRecessive =
      indiStatus === Status.Affected && project?.pathology !== 'Dominant'

    if (isAffectedRecessive) {
      const { bounds, bounds2 } = getBoundsForAffected(variants)
      return countByPosition(rows, role, individualType, bounds, bounds2)
    }

    const bounds = getVariantBounds(variants)
    return countByPosition(rows, role, individualType, bounds)
  }

  return computeNoPanelCounts(role, individualType)
}

// ─── Función principal (sustituye handleParentsConfidenceLevel) ───────────────

const handleParentsConfidenceLevel = () => {
  const motherIndividual = data2?.preProcessedData?.find(
    (i) => i.role === RolePGDTest.Female
  )
  const fatherIndividual = data2?.preProcessedData?.find(
    (i) => i.role === RolePGDTest.Male
  )

  const motherCounts = computeParentCounts(
    RolePGDTest.Female,
    'mother_info',
    maternalVar ?? [],
    motherIndividual?.status
  )
  const fatherCounts = computeParentCounts(
    RolePGDTest.Male,
    'father_info',
    paternalVar ?? [],
    fatherIndividual?.FinalStatus
  )

  setUpVari(motherCounts.up)
  setInVari(motherCounts.in)
  setDownVari(motherCounts.down)
  setUpVari2(motherCounts.up2)
  setInVari2(motherCounts.in2)
  setDownVari2(motherCounts.down2)

  setUpVariFather(fatherCounts.up)
  setInVariFather(fatherCounts.in)
  setDownVariFather(fatherCounts.down)
  setUpVari2Father(fatherCounts.up2)
  setInVari2Father(fatherCounts.in2)
  setDownVari2Father(fatherCounts.down2)
}


  const handleInfoAnalizedByChangeProject = () => {
    const loggedUser = authService.get()
    let name = loggedUser.firstName + ' ' + loggedUser.lastName
    //getDateTime on string
    let date = new Date().toLocaleString()
    let analizeBy = name + ' ' + date
    if (props?.project) {
      const updatedProject = Object.assign(
        { ...props?.project },
        {
                    resultTableID: project?.resultTableID,
          resultTableWithEmbryosID: project?.resultTableWithEmbryosID,
          parentsFasadeID: project?.parentsFasadeID,
          
          infoAnalizedBy: props?.project?.infoAnalizedBy === '' ? analizeBy : '',
        }
      )
      projectService.update(updatedProject).subscribe((res) => {
        setProject(updatedProject)
        props.setProject(updatedProject)
      })
    }
  }

  const handleChangeInfoValidate = () => {
    const loggedUser = authService.get()
    let name = loggedUser.firstName + ' ' + loggedUser.lastName
    let date = new Date().toLocaleString()
    let validateBy = name + ' ' + date
    if (props?.project) {
      const updatedProject = Object.assign(
        { ...props?.project },
        {
                    resultTableID: project?.resultTableID,
          resultTableWithEmbryosID: project?.resultTableWithEmbryosID,
          parentsFasadeID: project?.parentsFasadeID,
          infoValidateBy: props?.project?.infoValidateBy === '' ? validateBy : '',
        }
      )
      projectService.update(updatedProject).subscribe((res) => {
        setProject(updatedProject)
        props.setProject(updatedProject)
      })
    }
  }

  const handleEmbryoAnalizedByChangeProject = () => {
    const loggedUser = authService.get()
    let name = loggedUser.firstName + ' ' + loggedUser.lastName
    let date = new Date().toLocaleString()
    let embryoAnalizedBy = name + ' ' + date
    if (props?.project) {
      const updatedProject = Object.assign(
        { ...props?.project },
        {          resultTableID: project?.resultTableID,
          resultTableWithEmbryosID: project?.resultTableWithEmbryosID,
          embryoAnalizedBy: props?.project.embryoAnalizedBy === '' ? embryoAnalizedBy : '',
        }
      )
      projectService.update(updatedProject).subscribe((res) => {
        setProject(updatedProject)
        props.setProject(updatedProject)
      })
    }
  }

  const handleChangeEmbryoValidate = () => {
    const loggedUser = authService.get()
    let name = loggedUser.firstName + ' ' + loggedUser.lastName
    //getDateTime on string
    let date = new Date().toLocaleString()
    let embryoValidateBy = name + ' ' + date
    if (props?.project) {
      const updatedProject = Object.assign(
        { ...props?.project },
        {          resultTableID: project?.resultTableID,
          resultTableWithEmbryosID: project?.resultTableWithEmbryosID,
          embryoValidateBy: project.embryoValidateBy === '' ? embryoValidateBy : '',
        }
      )
      projectService.update(updatedProject).subscribe((res) => {
        setProject(updatedProject)
        props.setProject(updatedProject)
      })
    }
  }

  const openSaveMutationModal = () => {
    updateIndividuals()
    if (mutationChanges || changes) {
      mutationChanges && setSaveMutationModal(true)
      changes && setChangesModal(true)
      // markedMutation && setSaveMutationModal(true)
    } else props.return(false)
  }

  const closeSaveMutationModal = () => {
    mutationChanges && setSaveMutationModal(false)
  }

  const closeChangesModal = () => {
    changes && setChangesModal(false)
    props.return(false)
  }

  const saveChanges = () => {
    wordsChanges.forEach((word) => {
      wordService.update(word).subscribe(() => {})
    })
    closeChangesModal()
    props.return(false)
  }

  const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
    const selectedColor = event.target.value as string
    setSelectedOption(selectedColor)
    handleChangeColor(selectedColor)
  }

  // const runParentsSnipetsProcess = () => {
  //     // setModalPreviewOpened(true)
  //     setDataLoading(true)
  //     embryoService.runEmbryoSnipetsProcess(project?.id || '').subscribe((res: any) => {
  //         let aux = res;
  //         let auxPreprocessed = res.preProcessedData;
  //         auxPreprocessed = auxPreprocessed.map((item: any) => ({ ...item, seeEmbryo: true }));
  //         aux.preProcessedData = auxPreprocessed;
  //         // setIsLoading(true)
  //         // setDataLoaded(true)
  //         setData2(aux)

  //         setDataLoading(false)
  //     })
  // }

  const styles3 = usaStyles()

        console.log("indi",data2)
  
  const handleChangeSeeEmbryo = (embryo: any) => {
    let aux = { ...data2 }
    let auxPreprocessed = data2?.preProcessedData.map((pd: any) =>
      pd.name === embryo?.name ? { ...pd, seeEmbryo: !pd.seeEmbryo } : pd
    )

    aux.preProcessedData = auxPreprocessed
    setData2(aux)
  }

  const handleChangeSeeIndividual = (embryo: any) => {
    let aux = { ...data2 }
    let auxPreprocessed = data2?.preProcessedData.map((pd: any) =>
      pd.name === embryo?.fileName ? { ...pd, seeEmbryo: !pd.seeEmbryo } : pd
    )

    aux.preProcessedData = auxPreprocessed
    setData2(aux)
  }

  const isEmbryoHidden = (name: string) => {
    let ret = false
    let embs = data2.preProcessedData.filter((d) => d.name === name)

    if (embs?.length > 0) {
      ret = embs[0].seeEmbryo
    }
    return !ret
  }

  const isEmbryoHidden3 = (role: string) => {
    let ret = false
    // let embs = data2.preProcessedData.filter((d) => d.role === role)
    
    let embs = data2.preProcessedData.filter((d) =>{
      if (d.role === Individuals.FEMALE_BROTHER) {
        return role === 0}
      return d.role === role
    })

    if (embs?.length > 0) {
      ret = embs[0].seeEmbryo
    }
    return !ret
  }

  const isEmbryoHidden2 = (name: string) => {
    let ret = false
    let embs = data2.preProcessedData.filter((d) => d.name === name)

        if (embs?.length > 0 ) {
            ret = embs[0].seeEmbryo
        }
        return !ret
    }

  
  
      const colorP = (data: any, aName: string, fStatus: FinalStatus, column: number): string => {
          if (individuals.length === 2) return  "#F2EE81"
          if (aName !== "P1" && aName !== "P2"  ) return "#F2EE81";
          switch (project?.pathology){
              case "X-Linked":
                  if (fStatus === FinalStatus.Affected){
                      if  (data.role === RolePGDTest.MaleMother ||
                          data.role === RolePGDTest.FemaleMother ||
                          data.role === RolePGDTest.Female ||
                          (data.role === RolePGDTest.Child && project?.childGender === 2) ||
                          (data.role === RolePGDTest.Embryo && data.embryoGender !== "male")
                      ) {
                                  return "#ff7b54"; // Rojo claro (Afectado) 
                          } else if (column === 1) {
                              return "#ff7b54";
                          } else return "#96f68a";
                  } else if (fStatus === FinalStatus.CarrierFromFather){
                      return column === 1 ?  "#96f68a" :  "#ff7b54";
                  }  else if (fStatus === FinalStatus.CarrierFromMother){
                      return column === 2 ?  "#96f68a" :  "#ff7b54";
                  } else return "#96f68a";
  
               
         
                  default:
                      const child = data2.preProcessedData.find(i => i.role === RolePGDTest.Child)
                      if (fStatus === FinalStatus.Affected)return "#ff7b54"; // Rojo claro (Afectado) 
                      else if (fStatus === FinalStatus.CarrierFromFather){
                          if(child && (child.finalStatus === FinalStatus.NonCarrier || child.finalStatus === FinalStatus.Null) &&
                          (data.role === RolePGDTest.Male || data.role === RolePGDTest.Female)){
                              return column === 1 ?  "#96f68a" :  "#ff7b54";
                      }
                          return column === 1 ?  "#96f68a" :  "#ff7b54";
                      }  else if (fStatus === FinalStatus.CarrierFromMother){
                          if(child && (child.finalStatus === FinalStatus.NonCarrier || child.finalStatus === FinalStatus.Null) &&
                          (data.role === RolePGDTest.Male || data.role === RolePGDTest.Female) ){
                              return column === 1 ?  "#96f68a" :  "#ff7b54";
                      }
                          return column === 2 ?  "#96f68a" :  "#ff7b54";
                      } else return "#96f68a";
      
              
      
          
          };
        }

  const renderHeader = (data, i, sortedData) => {
    const role = rolePgdTest()[data?.role]
    const isEmbryo = role === 'embryo'
    const roleName = isEmbryo ? data.name.replace(/_/g, ' ') : role

    if (isEmbryoHidden(data.name)) return null

    const pGroupClass = qualityCoverage && afOn
      ? styles.subContainerAll
      : qualityCoverage || afOn
      ? styles.subContainerQC
      : styles.subContainer

    const qcGroupClass = qualityCoverage && afOn ? styles.subContainerAll : styles.subContainerQC
    const afGroupClass = qualityCoverage && afOn ? styles.subContainerAll : styles.subContainerQC

    const embryoBaseClass =
      qualityCoverage && afOn
        ? styles.headerDivQualityCoverageAll
        : qualityCoverage || afOn
        ? styles.headerDivQualityCoverageStep1
        : styles.headerDiv

    let headerClass =
      data.role === RolePGDTest.Female
        ? (qualityCoverage && afOn
            ? styles.headerFixed1QualityCoverageAll
            : qualityCoverage || afOn
            ? styles.headerFixed1QualityCoverageStep1
            : styles.headerFixed1)
        : data.role === RolePGDTest.Male
        ? (qualityCoverage && afOn
            ? styles.headerFixed2QualityCoverageAll
            : qualityCoverage || afOn
            ? styles.headerFixed2QualityCoverageStep1
            : styles.headerFixed2)
        : `${embryoBaseClass} ${
            i > 0 &&
            sortedData[i - 1]?.role !== RolePGDTest.Embryo &&
            data.role === RolePGDTest.Embryo
              ? styles['embryo-separator']
              : ''
          }`

    const columnKey =
      data.role === RolePGDTest.Embryo
        ? (data?.sampleName || data?.name)
        : String(data?.role)

    const AlleleModeToggle = () => {
      const currentMode = alleleModes[columnKey] || 'OFF'

      const nextMode = () => {
        const newMode = currentMode === 'OFF' ? 'HET' : currentMode === 'HET' ? 'HOM' : 'OFF'
        setAlleleModes(prev => ({ ...prev, [columnKey]: newMode }))
      }

      const background =
        currentMode === 'OFF'
          ? '#9E9E9E'
          : '#96F68A'

      return (
        <div
          onClick={nextMode}
          title={currentMode === 'OFF' ? 'OFF' : currentMode === 'HET' ? t('heterozygousAbbreviation') : t('homozygousAbbreviation')}
          style={{
            color: currentMode === 'OFF' ? '#FFFFFF' : '#000000',
            background: background,
            border: '1px solid grey',
            padding: '3px 16px',
            fontSize: '11px',
            fontWeight: 'bold',
            textTransform: 'uppercase' as const,
            cursor: 'pointer',
            userSelect: 'none' as const,
            whiteSpace: 'nowrap' as const,
            margin: '0',
            width: '100%',
            textAlign: 'center' as const,
            borderRadius: '4px',
            fontFamily: 'inherit',
            boxSizing: 'border-box' as const,
          }}
        >
          {currentMode === 'OFF' ? 'OFF' : currentMode === 'HET' ? t('heterozygousAbbreviation') : t('homozygousAbbreviation')}
        </div>
      )
    }

    return (
      <div className={headerClass}>
        <div className={styles.roleNameDiv}>{roleName}</div>
        <AlleleModeToggle />
        <div className={styles.pContainer0}>
          <div className={styles.pContainer1}>
            <div className={pGroupClass}>
              <div
                className={styles.p1Div}
                style={{ backgroundColor: colorP(data, data.a1ColumnName, data.finalStatus, 1) }}>
                {data.a1ColumnName !== 'P1' ? 'LR' : data.a1ColumnName}
              </div>
              <div
                className={styles.p2Div}
                style={{ backgroundColor: colorP(data, data.a2ColumnName, data.finalStatus, 2) }}>
                  {data.a2ColumnName !== 'P2' ? 'LR' : data.a2ColumnName}
              </div>
            </div>
            {qualityCoverage && (
              <div className={qcGroupClass}>
                <div className={styles.pQu}>{t('qu')}</div>
                <div className={styles.pQu}>{t('co')}</div>
              </div>
            )}
            {afOn && (
              <div className={afGroupClass}>
                <div className={styles.pQu}>{t('1af')}</div>
                <div className={styles.pQu}>{t('2af')}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  const updateIndividuals = () => {
    let individualsAux = [...individuals]
    let individualsIndex = individuals?.findIndex((indi) => indi.individual === RolePGDTest.Female)

    individualsAux[individualsIndex].upInfo = upVari + upVari2
    individualsAux[individualsIndex].inInfoInfo = inVari + inVari2
    individualsAux[individualsIndex].downInfo = downVari + downVari2
    individualsAux[individualsIndex].confidenceLevel = confidenceMotherRange?.level

    individualService.update2(individualsAux[individualsIndex]?.toDTO()).subscribe((res) => {})

    individualsIndex = individuals?.findIndex((indi) => indi.individual === RolePGDTest.Male)

    individualsAux[individualsIndex].upInfo = upVariFather + upVari2Father
    individualsAux[individualsIndex].inInfoInfo = inVariFather + inVari2Father
    individualsAux[individualsIndex].downInfo = downVariFather + downVari2Father
    individualsAux[individualsIndex].confidenceLevel = confidenceFatherRange?.level

    individualService.update2(individualsAux[individualsIndex]?.toDTO()).subscribe((res) => {})

    props.setIndividuals(individualsAux)
    props.setEmbryos(embryos)
  }
  
  const handleExportExcel = async () => {
    const visibleRows = data2.resultTableData.filter(
      (row: any) => getDataComponentFiltered(row) !== ''
    )
    const parentsCount =
      data2?.preProcessedData?.filter(
        (p: any) => p.role === RolePGDTest.Female || p.role === RolePGDTest.Male
      )?.length ?? 0
    const visibleIndividuals = data2?.preProcessedData?.filter((ind: any) => {
      if (ind.role === RolePGDTest.Embryo) {
        return !isEmbryoHidden2(ind.name)
      }
      return !isEmbryoHidden3(ind.role)
    })
    await exportResultsToExcel(
      data2,
      visibleRows,
      project?.name,
      project,
      parentsCount,
      visibleIndividuals,
      data2?.preProcessedData?.length ===2
      
    )
  }

  const handleChangeView = () => {
    updateIndividuals()
    if (mutationChanges || changes) {
      mutationChanges && setSaveMutationModal(true)
      changes && setChangesModal(true)
    } else {

        let individualsAux = [...individuals]
    let individualsIndex = individuals?.findIndex((indi) => indi.individual === RolePGDTest.Female)

    individualsAux[individualsIndex].upInfo = upVari + upVari2
    individualsAux[individualsIndex].inInfoInfo = inVari + inVari2
    individualsAux[individualsIndex].downInfo = downVari + downVari2
    individualsAux[individualsIndex].confidenceLevel = confidenceMotherRange?.level
    var individualsIndex2 = individuals?.findIndex((indi) => indi.individual === RolePGDTest.Male)

   individualsAux[individualsIndex2].upInfo = upVariFather + upVari2Father
   individualsAux[individualsIndex2].inInfoInfo = inVariFather + inVari2Father
   individualsAux[individualsIndex2].downInfo = downVariFather + downVari2Father
   individualsAux[individualsIndex2].confidenceLevel = confidenceFatherRange?.level

   props.setIndividuals(individualsAux)
   props.setEmbryos(embryos)
    individualService.update2(individualsAux[individualsIndex]?.toDTO()).subscribe((res) => {

        individualService.update2(individualsAux[individualsIndex2]?.toDTO()).subscribe((res2) => {

          if(props.currentStep === 1) props.setFromIndi(true)
          if(props.currentStep === 2) props.setFromEmb(true)

          props.setViewResult(false)
          props.setCurrentStep(3)
        })
      })
   
    }
  }

  const handlePositionClick = (data: any) => {
    if (igvEnabled) {
      const locus = `${data.chromosoma}:${data.position}`
      setSelectedLocus(locus)
    }
  }

  const carrierFrom = (allele: number, embryo: Embryo) => {
    
    if (embryo?.finalStatus === FinalStatus.NonCarrier) {
      if ((allele === 1 && embryo?.a1ColumnName !== 'P1')||(allele === 2 && embryo?.a2ColumnName !== 'P2')) {
         if (embryo?.a1ColumnName !== 'P1') {
          return embryo?.a1ColumnName === 'LRNC'
            ? 'Recombinant but seems to be Non-Carrier'
            : embryo?.a1ColumnName === 'LRCM' 
              ? "Recombinant but seems to be Carrier from mother"
              : "Likely Recombinant" 
            }
          if (embryo?.a2ColumnName !== 'P2') {
          return embryo?.a2ColumnName === 'LRNC'
            ? 'Recombinant but seems to be Non-Carrier'
            : embryo?.a2ColumnName === 'LRCF' 
              ? "Recombinant but seems to be Carrier from father"
              : "Likely Recombinant"
        }
        return "Recombinant, Non-carrier allele"}
      return 'Non-carrier allele'}
    else if (allele === 1) {

        if (embryo?.a1ColumnName !== 'P1') {
          return embryo?.a1ColumnName === 'LRNC'
            ? 'Recombinant but seems to be Non-Carrier'
            : embryo?.a1ColumnName === 'LRCM' 
              ? "Recombinant but seems to be Carrier from mother"
              : "Likely Recombinant"
        } else return embryo?.finalStatus === FinalStatus.CarrierFromMother || embryo?.finalStatus === FinalStatus.Affected?'Maternal carrier' : 'Non-carrier allele'
      
    } else if (allele === 2) {
   
        if (embryo?.a2ColumnName !== 'P2') {
          return embryo?.a2ColumnName === 'LRNC'
            ? 'Recombinant but seems to be Non-Carrier'
            : embryo?.a2ColumnName === 'LRCF' 
              ? "Recombinant but seems to be Carrier from father"
              : "Likely Recombinant"
        } else return embryo?.finalStatus === FinalStatus.CarrierFromFather || embryo?.finalStatus === FinalStatus.Affected? 'Paternal carrier': 'Non-carrier allele'
    }
  }

  const disableOption = () => {
    let variantPosition = []
    for (let i = 0; i < maternalVar.length; i++) {
      if (maternalVar[i].type === 'SNP') {
        variantPosition.push(maternalVar[i].position)
      } else {
        variantPosition.push(maternalVar[i].start)
        variantPosition.push(maternalVar[i].end)
      }
    }
    variantPosition.sort()

    if (
      data2.resultTableData?.findIndex(
        (data) => data.position === variantPosition[variantPosition.length - 1]
      ) -
        data2.resultTableData?.findIndex((data) => data.position === variantPosition[0]) >
      15
    ) {
      setIsDisable(true)
    }

    variantPosition = []
    for (let i = 0; i < paternalVar.length; i++) {
      if (paternalVar[i].type === 'SNP') {
        variantPosition.push(paternalVar[i].position)
      } else {
        variantPosition.push(paternalVar[i].start)
        variantPosition.push(paternalVar[i].end)
      }
    }
    variantPosition.sort()

    if (
      data2.resultTableData?.findIndex(
        (data) => data.position === variantPosition[variantPosition.length - 1]
      ) -
        data2.resultTableData?.findIndex((data) => data.position === variantPosition[0]) >
      15
    ) {
      setIsDisable(true)
    }

    setIsDisable(false)
  }

  const indirectAnalisisResults = () => {
    return (
      <>
        <div style={{ 
          height: '100vh', 
          display: 'flex', 
          gap: '10px',
          maxHeight: igvEnabled ? '75vh' : 'none'
        }}>
          {/* Tabla de resultados */}
          <div style={{ 
            width: igvEnabled ? '50%' : '100%',
            transition: 'width 0.3s ease',
            height: igvEnabled ? '75vh' : 'auto',
            overflowY: igvEnabled ? 'auto' : ''
          }}>
            <div className={styles.overflows}>
              <div className={styles.container2}>
                {filterUniqueRoles(data2?.preProcessedData)
                  ?.sort((a, b) => {
                    if (a.role === b.role) {
                      return a.embryo - b.embryo
                    } else return customOrder[a.role] - customOrder[b.role]
                  })
                  ?.map((data, i, sortedData) => (
                    <>
                      {i === 0 && (
                        <div className={styles.container0}>
                          {/* {props.currentStep === 2 &&
                          <Button
                          className={styles.addMutationButton}
                          onClick={openModalAddMutation}>{t('addMutation')}</Button>
                  
                      } */}
                          <div className={styles.chromPos}>
                            <div className={styles.chromContainer}>{t('chrom')}</div>
                            <div className={styles.borderContainer} />
                            <div className={styles.posContainer}>{t('position')}</div>
                          </div>
                        </div>
                      )}
                      {renderHeader(data, i, sortedData)}
                    </>
                  ))}
              </div>
              <div className={styles.scrollContainer}>
                {/* FIND */}
                {data2?.resultTableData?.map((data: any) => (
                  <>{getDataComponentFiltered(data)}</>
                ))}
              </div>
            </div>
          </div>

          {/* IGV Viewer */}
          {igvEnabled && (
            <div style={{ 
              width: '50%', 
              borderLeft: '2px solid #ddd',
              paddingLeft: '10px',
              height: '75vh',
              overflowY: 'auto',
              overflowX: 'hidden'
            }}>
              <IGV
                project={props.project}
                individuals={individuals}
                embryos={embryos}
                variants={maternalVar.concat(paternalVar)}
                externalLocus={selectedLocus}
                hideControls={true}
                setViewIGV={() => {}}
              />
            </div>
          )}
        </div>
      </>
    )
  }
  const confidenceTableOptions = (varaintList: MutationsPosition[], parent: string) => {
    const role = parent === 'maternal' ? RolePGDTest.Female : RolePGDTest.Male
    const indi = data2?.preProcessedData?.find((ind) => ind.role === role)
    return individuals?.length === 2 ? (
      varaintList.length === 0 ? (
        testData?.Panel?.genRegion !== 'Gene' ? (
          <>
            <TableRow>
              <TableCell>{t('aboveGen')}</TableCell>
              <TableCell>
                {parent === 'maternal' ? project?.femaleUpstream : project?.maleUpstream}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t('intraRegion')}</TableCell>
              <TableCell>
                {parent === 'maternal' ? project?.femaleIntrangenic : project?.maleIntrangenic}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t('BelowGen')}</TableCell>
              <TableCell>
                {parent === 'maternal' ? project?.femaleDownstream : project?.maleDownstream}
              </TableCell>
            </TableRow>
          </>
        ) : (
          <>
            <TableRow>
              <TableCell>{t('infoPosition')}</TableCell>
              <TableCell>
                {parent === 'maternal'
                  ? upVari
                  : upVariFather}
              </TableCell>
            </TableRow>
          </>
        )
      ) : (
        <>
          <TableRow>
            <TableCell>{t('upPosition')}</TableCell>
            <TableCell>{parent === 'maternal' ? upVari : upVariFather}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t('downPosition')}</TableCell>
            <TableCell>{parent === 'maternal' ? downVari : downVariFather}</TableCell>
          </TableRow>
        </>
      )
    ) : varaintList.length !== 0 ? (
      <>
        <TableRow>
          <TableCell />
          <TableCell>
            {indi.finalStatus === FinalStatus.CarrierFromMother
              ? t('carrierAllel')
              : indi.finalStatus === FinalStatus.Affected
              ? t('carrierAllel') + '1'
              : t('healthyAllele')}
          </TableCell>
          <TableCell>
            {indi.finalStatus === FinalStatus.CarrierFromFather
              ? t('carrierAllel')
              : indi.finalStatus === FinalStatus.Affected
              ? t('carrierAllel') + '2'
              : t('healthyAllele')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('aboveGen')}</TableCell>
          <TableCell>{parent === 'maternal' ? upVari : upVariFather}</TableCell>
          <TableCell>{parent === 'maternal' ? upVari2 : upVari2Father}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('BelowGen')}</TableCell>
          <TableCell>{parent === 'maternal' ? downVari : downVariFather}</TableCell>
          <TableCell>{parent === 'maternal' ? downVari2 : downVari2Father}</TableCell>
        </TableRow>
      </>
    ) : testData?.Panel?.genRegion !== 'Gene' ? (
      <>
        <TableRow>
          <TableCell />
          <TableCell>
            {indi.finalStatus === FinalStatus.Affected
              ? t('carrierAllel') + ' 1'
              : indi.finalStatus === FinalStatus.CarrierFromMother
              ? t('carrierAllel')
              : indi.finalStatus === FinalStatus.NonCarrier
              ? t('healthyAllele') + ' 1'
              : t('healthyAllele')}
          </TableCell>
          <TableCell>
            {indi.finalStatus === FinalStatus.Affected
              ? t('carrierAllel') + ' 2'
              : indi.finalStatus === FinalStatus.CarrierFromFather
              ? t('carrierAllel')
              : indi.finalStatus === FinalStatus.NonCarrier
              ? t('healthyAllele') + ' 2'
              : t('healthyAllele')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('totalKeyPosition')}</TableCell>
          <TableCell>{parent === 'maternal' ? upVari : upVariFather}</TableCell>
          <TableCell>{parent === 'maternal' ? upVari2 : upVari2Father}</TableCell>
        </TableRow>
      </>
    ) : (
      <>
        <TableRow>
          <TableCell />
          <TableCell>
            {indi.finalStatus === FinalStatus.Affected
              ? t('carrierAllel') + ' 1'
              : indi.finalStatus === FinalStatus.CarrierFromMother
              ? t('carrierAllel')
              : indi.finalStatus === FinalStatus.NonCarrier
              ? t('healthyAllele') + ' 1'
              : t('healthyAllele')}
          </TableCell>
          <TableCell>
            {indi.finalStatus === FinalStatus.Affected
              ? t('carrierAllel') + ' 2'
              : indi.finalStatus === FinalStatus.CarrierFromFather
              ? t('carrierAllel')
              : indi.finalStatus === FinalStatus.NonCarrier
              ? t('healthyAllele') + ' 2'
              : t('healthyAllele')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('aboveGen')}</TableCell>
          <TableCell>{parent === 'maternal' ? upVari : upVariFather}</TableCell>
          <TableCell>{parent === 'maternal' ? upVari2 : upVari2Father}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('insideGen')}</TableCell>
          <TableCell>{parent === 'maternal' ? inVari : inVariFather}</TableCell>
          <TableCell>{parent === 'maternal' ? inVari2 : inVari2Father}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('BelowGen')}</TableCell>
          <TableCell>{parent === 'maternal' ? downVari : downVariFather}</TableCell>
          <TableCell>{parent === 'maternal' ? downVari2 : downVari2Father}</TableCell>
        </TableRow>
      </>
    )
  }

  const confidenceLevelIndividual = () => {
    const motherInx = individuals?.findIndex((ind) => ind.individual === RolePGDTest.Female)
    const fatherInx = individuals?.findIndex((ind) => ind.individual === RolePGDTest.Male)

    return (
      <div>
        <div className={styles.overflows} style={{ display: 'flex', flexDirection: 'row' }}>
          {motherInfo && (
            <TableContainer style={{ padding: '20px' }}>
              <Table size="small">
                <TableRow>
                  <TableCell
                    style={{ textAlign: 'left', fontWeight: 'bold', color: 'rgb(125, 191, 220)' }}>
                    {t('maternalInherit')}
                  </TableCell>
                  <TableCell
                    colSpan={individuals.length === 2 ? 1 : 2}
                    style={{ textAlign: 'center' }}>
                    {individuals[motherInx].status !== Status.NonCarrier &&
                      maternalVar.length > 0 &&
                      individuals.length > 2 && (
                        <CustomTooltip title={confidenceMotherRange?.Information}>
                          <Grid
                            style={{
                              backgroundColor: confidenceMotherRange?.color,
                              borderRadius: '5px',
                            }}>
                            {t('confidenceLevel')}: {confidenceMotherRange?.level}{' '}
                            <InfoOutlined style={{ fontSize: '14px' }} />
                          </Grid>
                        </CustomTooltip>
                      )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={individuals.length === 2 ? 2 : 3}
                    style={{ textAlign: 'center' }}>
                    {t('numOfInfoPos')}
                  </TableCell>
                </TableRow>

                {individuals && maternalVar && confidenceTableOptions(maternalVar, 'maternal')}

                <TableRow style={{ textAlign: 'left' }}>
                  <FormControlLabel
                    className={motherValidated ? styles.toggleOn : styles.toggleOff}
                    control={
                      <Switch
                        className={styles3.toggle}
                        checked={motherValidated}
                        onChange={() =>
                          validateInfo(!motherValidated, individuals[motherInx]?.individual)
                        }
                        color="primary"
                        style={{ color: '#FAFAFA' }}
                      />
                    }
                    labelPlacement="start"
                    label={'Validate'}
                    style={{ marginLeft: '0.2%' }}
                  />
                </TableRow>
              </Table>
            </TableContainer>
          )}

          {fatherInfo && (
            <TableContainer style={{ padding: '20px' }}>
              <Table size="small">
                <TableRow>
                  <TableCell
                    style={{ textAlign: 'left', fontWeight: 'bold', color: 'rgb(125, 191, 220)' }}>
                    {t('paternalInherit')}
                  </TableCell>
                  <TableCell
                    colSpan={individuals.length === 2 ? 1 : 2}
                    style={{ textAlign: 'center' }}>
                    {individuals[fatherInx].status !== Status.NonCarrier &&
                      paternalVar.length > 0 &&
                      individuals.length > 2 && (
                        <CustomTooltip title={confidenceFatherRange?.Information}>
                          <Grid
                            style={{
                              backgroundColor: confidenceFatherRange?.color,
                              borderRadius: '5px',
                            }}>
                            {t('confidenceLevel')}: {confidenceFatherRange?.level}{' '}
                            <InfoOutlined style={{ fontSize: '14px' }} />
                          </Grid>
                        </CustomTooltip>
                      )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={individuals.length === 2 ? 2 : 3}
                    style={{ textAlign: 'center' }}>
                    {t('numOfInfoPos')}
                  </TableCell>
                </TableRow>
                {individuals && paternalVar && confidenceTableOptions(paternalVar, 'paternal')}

                <TableRow style={{ textAlign: 'left' }}>
                  <FormControlLabel
                    className={fatherValidated ? styles.toggleOn : styles.toggleOff}
                    control={
                      <Switch
                        className={styles3.toggle}
                        checked={fatherValidated}
                        onChange={() =>
                          validateInfo(!fatherValidated, individuals[fatherInx]?.individual)
                        }
                        color="primary"
                        style={{ color: '#FAFAFA' }}
                      />
                    }
                    labelPlacement="start"
                    label={'Validate'}
                    style={{ marginLeft: '0.2%' }}
                  />
                </TableRow>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    )
  }

  const someHasBoth = (infoCont: EmbryoConfidence[]) =>{
    let someHas = false

    infoCont.forEach(i => {if(i.kpForBoth) someHas=true})

    return someHas
  }

  const confidenceLevelEmbryo = () => {
    return (
      <div>
        <div className={styles.overflows} style={{ display: 'flex', flexDirection: 'column' }}>
          {motherInfo && (
            <TableContainer style={{ padding: '20px' }}>
              <Table size="small">
                <TableRow>
                  <TableCell
                    colSpan={embryos?.length + 1}
                    style={{ textAlign: 'left', fontWeight: 'bold', color: 'rgb(125, 191, 220)' }}>
                    {t('maternalInherit')}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell />
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell style={embryosConfMoth[i]?.kpForBoth ? { textAlign: 'center', color:'#ff7b54'} :{ textAlign: 'center' }}>{e.name}{embryosConfMoth[i]?.kpForBoth && '*'}</TableCell>
                      )
                  )}
                </TableRow>
                <TableRow>
                  <TableCell style={{ textAlign: 'left' }}>Suggested status</TableCell>
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell  style={  { textAlign: 'center' } }>
                          {embryosConfMoth[i]?.inconclusive? t('inconclusive')
                            :carrierFrom(
                            1,
                            data2?.preProcessedData.find((ppd) => ppd.name === e.name)
                          )}
                        </TableCell>
                      )
                  )}
                </TableRow>
                <TableRow>
                  <TableCell style={{ textAlign: 'left' }}>
                    {maternalVar.length > 0 ? t('aboveGen') : t('upPosition')}
                  </TableCell>
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell style={{ textAlign: 'center' }}>
                          {embryosConfMoth[i]?.upInfo}
                        </TableCell>
                      )
                  )}
                </TableRow>
                {maternalVar.length === 0 && (
                  <TableRow>
                    <TableCell style={{ textAlign: 'left' }}>{t('intraRegion')}</TableCell>
                    {embryos.map(
                      (e, i) =>
                        filterUniqueRoles(data2?.preProcessedData)?.filter(
                          (ind) => ind.name === e.name
                        )[0]?.seeEmbryo && (
                          <TableCell style={{ textAlign: 'center' }}>
                            {embryosConfMoth[i]?.inInfo}
                          </TableCell>
                        )
                    )}
                  </TableRow>
                )}
                <TableRow>
                  <TableCell style={{ textAlign: 'left' }}>
                    {maternalVar.length > 0 ? t('BelowGen') : t('downPosition')}
                  </TableCell>
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell style={{ textAlign: 'center' }}>
                          {embryosConfMoth[i]?.downInfo}
                        </TableCell>
                      )
                  )}
                </TableRow>
                {maternalVar.length > 0 && (
                  <TableRow style={{ textAlign: 'left' }}>
                    <TableCell style={{ textAlign: 'left' }}>{t('confidenceLevel')}</TableCell>
                    {embryos.map(
                      (e, i) =>
                        filterUniqueRoles(data2?.preProcessedData)?.filter(
                          (ind) => ind.name === e.name
                        )[0]?.seeEmbryo && (
                          <TableCell style={{ textAlign: 'center' }}>
                            <CustomTooltip title={embryosConfMoth[i]?.levelConfidence.Information}>
                              <Grid
                                style={{
                                  backgroundColor: embryosConfMoth[i]?.levelConfidence.color,
                                  borderRadius: '5px',
                                }}>
                                {t('confidenceLevel')}: {embryosConfMoth[i]?.levelConfidence.level}{' '}
                                <InfoOutlined style={{ fontSize: '14px' }} />
                              </Grid>
                            </CustomTooltip>
                          </TableCell>
                        )
                    )}
                  </TableRow>
                )}
                <TableRow style={{ textAlign: 'left' }}>
                  <TableCell style={{ textAlign: 'left' }}>Validate</TableCell>
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
                          <FormControlLabel
                            className={e.validatedMaternal ? styles.toggleOn : styles.toggleOff}
                            control={
                              <Switch
                                className={styles3.toggle}
                                checked={e.validatedMaternal}
                                onChange={() => validateInfoEmbryo('p1', !e.validatedMaternal, i)}
                                color="primary"
                                style={{ color: '#FAFAFA' }}
                              />
                            }
                            labelPlacement="start"
                            label={'Validate'}
                            style={{ marginLeft: '0.2%' }}
                          />
                        </TableCell>
                      )
                  )}
                </TableRow>
              </Table>
              <div style={{color: '#ff7b54'}}> 
                {someHasBoth(embryosConfMoth) && "*Key positions for both maternal alleles detected. Manual review is recommended." }
              </div>
            </TableContainer>
          )}

          {fatherInfo && (
            <TableContainer style={{ padding: '20px' }}>
              <Table size="small">
                <TableRow>
                  <TableCell
                    colSpan={embryos?.length + 1}
                    style={{ textAlign: 'left', fontWeight: 'bold', color: 'rgb(125, 191, 220)' }}>
                    {t('paternalInherit')}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell />
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell style={ embryosConfFath[i]?.kpForBoth ? { textAlign: 'center', color:'#ff7b54'} : { textAlign: 'center' } }>{e.name}{embryosConfFath[i]?.kpForBoth && '*'}</TableCell>
                      )
                  )}
                </TableRow>
                <TableRow>
                  <TableCell style={{ textAlign: 'left' }}>Suggested status</TableCell>
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell style={{ textAlign: 'center' }}>
                          {embryosConfFath[i]?.inconclusive? t('inconclusive')
                            :carrierFrom(
                            2,
                            data2?.preProcessedData.find((ppd) => ppd.name === e.name)
                          )}
                        </TableCell>
                      )
                  )}
                </TableRow>
                <TableRow>
                  <TableCell style={{ textAlign: 'left' }}>
                    {paternalVar.length > 0 ? t('aboveGen') : t('upPosition')}
                  </TableCell>
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell style={{ textAlign: 'center' }}>
                          {embryosConfFath[i]?.upInfo}
                        </TableCell>
                      )
                  )}
                </TableRow>
                {paternalVar.length === 0 && (
                  <TableRow>
                    <TableCell style={{ textAlign: 'left' }}>{t('intraRegion')}</TableCell>
                    {embryos.map(
                      (e, i) =>
                        filterUniqueRoles(data2?.preProcessedData)?.filter(
                          (ind) => ind.name === e.name
                        )[0]?.seeEmbryo && (
                          <TableCell style={{ textAlign: 'center' }}>
                            {embryosConfFath[i]?.inInfo}
                          </TableCell>
                        )
                    )}
                  </TableRow>
                )}
                <TableRow>
                  <TableCell style={{ textAlign: 'left' }}>
                    {paternalVar.length > 0 ? t('BelowGen') : t('downPosition')}
                  </TableCell>
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell style={{ textAlign: 'center' }}>
                          {embryosConfFath[i]?.downInfo}
                        </TableCell>
                      )
                  )}
                </TableRow>
                {paternalVar.length > 0 && (
                  <TableRow style={{ textAlign: 'left' }}>
                    <TableCell style={{ textAlign: 'left' }}>{t('confidenceLevel')}</TableCell>
                    {embryos.map(
                      (e, i) =>
                        filterUniqueRoles(data2?.preProcessedData)?.filter(
                          (ind) => ind.name === e.name
                        )[0]?.seeEmbryo && (
                          <TableCell style={{ textAlign: 'center' }}>
                            <CustomTooltip title={embryosConfFath[i]?.levelConfidence.Information}>
                              <Grid
                                style={{
                                  backgroundColor: embryosConfFath[i]?.levelConfidence.color,
                                  borderRadius: '5px',
                                }}>
                                {t('confidenceLevel')}: {embryosConfFath[i]?.levelConfidence.level}{' '}
                                <InfoOutlined style={{ fontSize: '14px' }} />
                              </Grid>
                            </CustomTooltip>
                          </TableCell>
                        )
                    )}
                  </TableRow>
                )}
                <TableRow style={{ textAlign: 'left' }}>
                  <TableCell style={{ textAlign: 'left' }}>validate</TableCell>
                  {embryos.map(
                    (e, i) =>
                      filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === e.name
                      )[0]?.seeEmbryo && (
                        <TableCell style={{ textAlign: 'center' }}>
                          <FormControlLabel
                            className={e.validatedPaternal ? styles.toggleOn : styles.toggleOff}
                            control={
                              <Switch
                                className={styles3.toggle}
                                checked={e.validatedPaternal}
                                onChange={() => validateInfoEmbryo('p2', !e.validatedPaternal, i)}
                                color="primary"
                                style={{ color: '#FAFAFA' }}
                              />
                            }
                            labelPlacement="start"
                            label={'Validate'}
                            style={{ marginLeft: '0.2%' }}
                          />
                        </TableCell>
                      )
                  )}
                </TableRow>
              </Table>
              <div style={{color: '#ff7b54'}}> 
                {someHasBoth(embryosConfFath) && "*Key positions for both paternal alleles detected. Manual review is recommended." }
              </div>
            </TableContainer>
          )}
        </div>
      </div>
    )
  }

  return (
    <>
      <Grid
        className={styles.stickyHeader}
        xs={12}
        style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%' }}>
        <Typography
          style={{
            fontSize: '17px',
            fontWeight: 'bold',
            color: 'rgb(125, 191, 220)',
            marginBottom: '0.5%',
          }}
          align="left">
          {project?.name}
        </Typography>
        <div className={styles.buttonDiv}>
          <Button onClick={openSaveMutationModal} className={classes.button}>
            {t('back')}
          </Button>
          <Button
            onClick={handleChangeView}
            style={{ marginLeft: '10px' }}
            className={classes.button}>
            {t('results')}
          </Button>
          <Button
            onClick={handleExportExcel}
            style={{ marginLeft: '10px' }}
            className={classes.button}>
            Export Excel
          </Button>
        </div>
        <Divider />
      </Grid>
      <div style={{ width: '100%', height: '100%' }}>
        <div className={styles.headerColumn}>
          <div className={styles.legendDiv}>
            <Legend />
          </div>
          <div className={styles.divFilters}>
            <div className={styles.filterColumn}>
              <FormControlLabel
                className={motherInfo ? styles.toggleOn : styles.toggleOff}
                control={
                  <Switch
                    className={styles3.toggle}
                    checked={motherInfo}
                    onChange={() => setMotherInfo(!motherInfo)}
                    color="primary"
                    style={{ color: '#FAFAFA' }}
                  />
                }
                key={5}
                label={'MOTHER INFO'}
                style={{ marginLeft: '0.2%' }}
              />
              <FormControlLabel
                className={fatherInfo ? styles.toggleOn : styles.toggleOff}
                control={
                  <Switch
                    className={styles3.toggle}
                    checked={fatherInfo}
                    onChange={() => setFatherInfo(!fatherInfo)}
                    color="primary"
                    style={{ color: '#FAFAFA' }}
                  />
                }
                key={5}
                label={'FATHER INFO'}
                style={{ marginLeft: '0.2%' }}
              />
            </div>
            <div className={styles.filterColumn2}>
              <FormControlLabel
                className={noInfo ? styles.toggleOn : styles.toggleOff}
                control={
                  <Switch
                    className={styles3.toggle}
                    checked={noInfo}
                    onChange={() => setNoInfo(!noInfo)}
                    color="primary"
                    style={{ color: '#FAFAFA' }}
                  />
                }
                key={5}
                label={'NO INFO'}
                style={{ marginLeft: '0.2%' }}
              />
              <FormControlLabel
                className={semiInfo ? styles.toggleOn : styles.toggleOff}
                control={
                  <Switch
                    className={styles3.toggle}
                    checked={semiInfo}
                    onChange={() => setSemiInfo(!semiInfo)}
                    color="primary"
                    style={{ color: '#FAFAFA' }}
                  />
                }
                key={5}
                label={'SEMI INFO'}
                style={{ marginLeft: '0.2%' }}
              />
            </div>
            <div className={styles.filterColumn3}>
              <FormControlLabel
                className={afOn ? styles.toggleOn : styles.toggleOff}
                control={
                  <Switch
                    className={styles3.toggle}
                    checked={afOn}
                    onChange={() => setAfOn(!afOn)}
                    color="primary"
                    style={{ color: '#FAFAFA' }}
                  />
                }
                key={5}
                label={'ALLELE FREQUENCY'}
                style={{ marginLeft: '0.2%' }}
              />
              <FormControlLabel
                className={qualityCoverage ? styles.toggleOn : styles.toggleOff}
                control={
                  <Switch
                    className={styles3.toggle}
                    checked={qualityCoverage}
                    onChange={() => setQualityCoverage(!qualityCoverage)}
                    color="primary"
                    style={{ color: '#FAFAFA' }}
                  />
                }
                key={5}
                label={'QUALITY/ COVERAGE'}
                style={{ marginLeft: '0.2%' }}
              />
            </div>
            <div className={styles.filterColumn3}>
              <FormControlLabel
                className={lowPositions ? styles.toggleOn : styles.toggleOff}
                control={
                  <Switch
                    className={styles3.toggle}
                    checked={lowPositions}
                    onChange={() => setLowPositions(!lowPositions)}
                    color="primary"
                    style={{ color: '#FAFAFA' }}
                  />
                }
                key={5}
                label={'LOW POSITIONS'}
                style={{ marginLeft: '0.2%' }}
              />
              {/* {hasValidVariant() && hasIgvTracks && ( */}
              { hasIgvTracks && (
                <FormControlLabel
                  className={igvEnabled ? styles.toggleOn : styles.toggleOff}
                  control={
                    <Switch
                      className={styles3.toggle}
                      checked={igvEnabled}
                      onChange={() => setIgvEnabled(!igvEnabled)}
                      color="primary"
                      style={{ color: '#FAFAFA' }}
                    />
                  }
                  key={6}
                  label={'GENOMICS VIEWER'}
                  style={{ marginLeft: '0.2%' }}
                />
              )}
            </div>
          </div>
        </div>
        <div className={styles.divTogglesPreview}>
          <TableContainer>
            <Table size="small">
              <Head
                fields={fields}
                styleHeader={{ fontWeight: 'bold', color: 'rgb(125, 191, 220)' }}
              />
              <Body fields={fields} />
              {individuals.map((individual, i) => (
                <TableRow>
                  <TableCell key="view" className={stylesComon.selectCell}>
                    <div onClick={() => handleChangeSeeIndividual(individual)}>
                      {filterUniqueRoles(data2?.preProcessedData)?.filter(
                        (ind) => ind.name === individual.fileName
                      )[0]?.seeEmbryo ? (
                        <CheckCircleIcon className={styles.iconChecked} />
                      ) : (
                        <CancelIcon className={styles.iconNotChecked} />
                      )}
                    </div>
                  </TableCell>
                  <TableCell key={`individualName${i}`}>{individual.sampleName}</TableCell>
                  <TableCell key={`fileName${i}`}>{individual.fileName}</TableCell>

                  <TableCell key={`status${i}`} className={stylesComon.selectCell}>
                    {statusTitle()[individual.status]}
                  </TableCell>
                  <TableCell key={`variant${i}`}>{individual.mutation}</TableCell>
                  <TableCell key={`nonCall${i}`}>
                    {Math.round(individual.nonCallRate * 100) / 100} %
                  </TableCell>
                </TableRow>
              ))}
            </Table>
          </TableContainer>
        </div>

        {embryos && embryos.length > 0 && (
          <div className={styles.divTogglesPreview} style={{ marginTop: '30px' }}>
            <TableContainer>
              <Table size="small">
                <Head
                  fields={fields2}
                  styleHeader={{ fontWeight: 'bold', color: 'rgb(125, 191, 220)' }}
                />
                <Body fields={fields2} />
                {embryos.map((embryo, i) => (
                  <TableRow style={{ height: '40px' }}>
                    <TableCell key="view" className={stylesComon.selectCell}>
                      <div onClick={() => handleChangeSeeEmbryo(embryo)}>
                        {filterUniqueRoles(data2?.preProcessedData)?.filter(
                          (ind) => ind.name === embryo?.name
                        )[0]?.seeEmbryo ? (
                          <CheckCircleIcon className={styles.iconChecked} />
                        ) : (
                          <CancelIcon className={styles.iconNotChecked} />
                        )}
                      </div>
                    </TableCell>
                    <TableCell key={`sampleName${i}`}>{embryo?.name}</TableCell>
                    <TableCell key={`fileName${i}`}>{embryo?.fileName}</TableCell>

                    <TableCell key={`status${i}`} className={stylesComon.selectCell}>
                      {
                      embryo?.inconclusive? t('inconclusive')
                      :checkLR(embryo)
                        ? recombinantStatus(embryo)
                        : checkAffected(
                            embryo,
                            data2?.preProcessedData.find(
                              (ppd) => ppd.name === embryo?.name
                            )?.finalStatus
                          )}
                    </TableCell>
                    {props.seeSex && <TableCell key={`sex${i}`}>{t(embryo?.embryoGender)}</TableCell>}
                    <TableCell key={`nonCall${i}`}>
                      {Math.round(embryo?.nonCallRate * 100) / 100} %
                    </TableCell>
                  </TableRow>
                ))}
              </Table>
            </TableContainer>
          </div>
        )}
        {/* <div className={styles.divToggles}>
                    {filterUniqueRoles(data2?.preProcessedData)
                        ?.sort((a: any, b: any) => customOrder[a.role] - customOrder[b.role])
                        ?.map((data: any) => (
                            <div
                                onClick={() => handleChangeSeeEmbryo(data)}
                                className={data.seeEmbryo ? styles.embryoChecked : styles.embryoNotChecked}>
                                <div className={data.seeEmbryo ? styles.labelChecked : styles.labelNotChecked}>
                                    {data.sampleName}
                                </div>
                                {data.seeEmbryo ? (
                                    <CheckCircleIcon className={styles.iconChecked}/>
                                ) : (
                                    <CancelIcon className={styles.iconNotChecked}/>
                                )}
                            </div>
                    ))}
                </div> */}

        {props.currentStep === 2 ? confidenceLevelEmbryo() : confidenceLevelIndividual()}
        {indirectAnalisisResults()}
        {props.currentStep === 1 && (
          <div className={styles.footerContainer}>
            {project?.infoAnalizedBy !== '' ? (
              <div className={styles.analizeByDiv}>
                <Typography>{t('analizeBy') + project?.infoAnalizedBy}</Typography>
              </div>
            ) : (
              <div className={styles.analizeByDiv}>
                <FormControlLabel
                  className={styles.toggle}
                  control={
                    <Switch
                      checked={project.infoAnalizedBy !== ''}
                      onChange={handleInfoAnalizedByChangeProject}
                    />
                  }
                  label={t('isAnalize')}
                  style={{ marginLeft: '0.2%' }}
                />
              </div>
            )}

            {project?.infoValidateBy !== '' ? (
              <div className={styles.validateByDiv}>
                <Typography>{t('validateBy') + project?.infoValidateBy}</Typography>
              </div>
            ) : (
              <div className={styles.validateByDiv}>
                <FormControlLabel
                  className={styles.toggle}
                  control={
                    <Switch
                      checked={project.infoValidateBy !== ''}
                      onChange={handleChangeInfoValidate}
                    />
                  }
                  label={t('isValidate')}
                  style={{ marginLeft: '0.2%' }}
                />
              </div>
            )}
          </div>
        )}
        {props.currentStep === 2 && (
          <div className={styles.footerContainer}>
            {project?.embryoAnalizedBy !== '' ? (
              <div className={styles.analizeByDiv}>
                <Typography>{t('analizeBy') + project?.embryoAnalizedBy}</Typography>
              </div>
            ) : (
              <div className={styles.analizeByDiv}>
                <FormControlLabel
                  className={styles.toggle}
                  control={
                    <Switch
                      checked={project.embryoAnalizedBy !== ''}
                      onChange={handleEmbryoAnalizedByChangeProject}
                    />
                  }
                  label={t('isAnalize')}
                  style={{ marginLeft: '0.2%' }}
                  disabled={props.currentStep !== 2}
                />
              </div>
            )}

            {project?.embryoValidateBy !== '' ? (
              <div className={styles.validateByDiv}>
                <Typography>{t('validateBy') + project?.embryoValidateBy}</Typography>
              </div>
            ) : (
              <div className={styles.validateByDiv}>
                <FormControlLabel
                  className={styles.toggle}
                  control={
                    <Switch
                      checked={project.embryoValidateBy !== ''}
                      onChange={handleChangeEmbryoValidate}
                    />
                  }
                  label={t('isValidate')}
                  style={{ marginLeft: '0.2%' }}
                  disabled={props.currentStep !== 2}
                />
              </div>
            )}
          </div>
        )}
      </div>

      <Modal open={alleleModal} onClose={() => setAlleleModal(false)}>
        <div className={styles3.containerAllele}>
          <div className={styles3.alleleTitle}>{t('chooseAllele')}</div>
          <div className={styles3.alleleDivs}>
            <FormControl className={styles3.formControl}>
              <InputLabel>{t('selectColor')}</InputLabel>
              <Select value={selectedOption} onChange={handleChange}>
                {options.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    style={{ backgroundColor: option.value }}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <CloseIcon className={styles3.alleleCloseIcon} onClick={() => setAlleleModal(false)} />
        </div>
      </Modal>

      <Modal
        open={(props.currentStep === 2 || props.currentStep === 1) && saveMutationModal}
        onClose={() => closeSaveMutationModal()}>
        <div className={styles.containerAllele}>
          <div className={styles.alleleTitle}>{t('mutationSave')}</div>
          <div className={styles.alleleDivs}>
            <div className={styles.allele} onClick={() => saveMutationsAndClose()}>
              {t('yes')}
            </div>
            <div className={styles.allele} onClick={() => closeSaveMutationModal()}>
              {t('no')}
            </div>
          </div>
          <CloseIcon className={styles.alleleCloseIcon} onClick={() => closeSaveMutationModal()} />
        </div>
      </Modal>

      <Modal
        open={(props.currentStep === 2 || props.currentStep === 1) && changesModal}
        onClose={() => closeChangesModal()}>
        <div className={styles.containerAllele}>
          <div className={styles.alleleTitle}>{t('mutationSave')}</div>
          <div className={styles.alleleDivs}>
            <div className={styles.allele} onClick={() => saveChanges()}>
              {t('yes')}
            </div>
            <div className={styles.allele} onClick={() => closeChangesModal()}>
              {t('no')}
            </div>
          </div>
          <CloseIcon className={styles.alleleCloseIcon} onClick={() => closeChangesModal()} />
        </div>
      </Modal>
      {dataLoading && (
        <Modal open={dataLoading}>
          <div className={styles.modalLoading}>
            <CircularProgress className={styles.circularProgress} />
          </div>
        </Modal>
      )}
    </>
  )
}
